import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { EngagementService } from 'src/app/services/EngagementService';
import { EngagementList, ImageModel, HeaderModel, ContactCardControl, ContactCardClick } from 'src/app/model/EngagementListModel';
import { PagerService } from "src/app/services/pager.service";
import { Engagements, EngagementStatus } from 'src/app/model/Engagement/Engagements';
import { EngagementUniqueDataModel, ClientModel, SolutionCodeModel, StatusModel, EppmdModel, IndustryModel } from 'src/app/model/EngagementFilterModel';
import { EngagementCardViewFilterModel, EngagementListViewFilterModel, EngagementCardViewForClientFilterModel, EngagementListViewForClientFilterModel } from 'src/app/model/engagement-filter-model';
import { LoadingScreenService } from 'src/app/services/loading-screen.service';
import { UserPreferenceData } from 'src/app/model/UserPreferenceModel';
import { ChangeOrderService } from 'src/app/services/change-order.service';
import { ChangeOrderModel } from 'src/app/model/change-order/change-order-model';
import { KeyValue } from 'src/app/model/KeyValue';
import { SharedService } from 'src/app/services/shared.service';
import { KpiService } from 'src/app/services/kpi.service';
import { UserDetails } from 'src/app/model/DocumentTemplate';
import { KpiMaster } from 'src/app/model/KPI/kpi-master';

declare var $;

@Component({
  selector: 'app-engagement-list-view',
  templateUrl: './engagement-list-view.component.html',
  styleUrls: ['./engagement-list-view.component.css'],
  providers: [EngagementService, LoadingScreenService, PagerService]
})
export class EngagementListViewComponent implements OnInit, OnDestroy {

  isMyEngagementLevel: boolean = false;
  passedClientId: number = 0;
  selectedKRPClientId: number;
  selectedEngagementId: number;
  engagementList: EngagementList[] = [];
  engagementCardList: EngagementList[] = [];
  ShowClientName: boolean = true;
  iShortcutCount: number;
  engagementCount: number = 0;
  engagementListCount: number = 0;
  engagementCountByClientId: number = 0;
  engagementListCountByClientId: number = 0;
  listViewnoOfrecordsPerPage: number = 20;
  cardViewnoOfrecordsPerPage: number = 20;
  listViewCurrentPageNumber: number = 1;
  cardViewCurrentPageNumber: number = 1;
  noOfrecordsPerPageList: number[];
  isloggedInUserAdmin: string;
  orderByColumn: string;
  orderByType: string;
  cardVieworderByColumn: string;
  cardVieworderByType: string;

  newImageModel: ImageModel = new ImageModel();
  headerModel: HeaderModel = new HeaderModel();
  headerImageModelList: ImageModel[] = [];
  headerModelList: HeaderModel[] = [];
  userObject: any;
  selectContactEmailId: string;
  applyFilterOnceAfterDataLoad: boolean;
  listCount: number = null;
  cardCount: number = null;
  DataMessage: string;
  listDataMessage: string;
  selectedEngagement: Engagements = new Engagements();
  engagementFilterUniqueDataList: EngagementUniqueDataModel;
  engagementFilterUniqueDataByClientIdList: EngagementUniqueDataModel;
  clientsList: ClientModel[] = [];
  solutionCodeList: SolutionCodeModel[] = [];
  eppmdList: EppmdModel[] = [];
  industryList: IndustryModel[] = [];
  engagementStatusList: StatusModel[] = [];
  solutionCodeListForClient: SolutionCodeModel[] = [];
  eppmdListForClient: EppmdModel[] = [];
  industryListForClient: IndustryModel[] = [];
  engagementStatusListForClient: StatusModel[] = [];
  ClientMappedValue: string;
  ClientListMappedValue: string;
  userName: string;
  clientId: number = 0;
  clientsId: string = '';
  solutionCodeId: number = 0;
  eppmdEMail: string = '';
  industryId: number = 0;
  engagementStatusName: string = '';

  currentSolutionCodeForClientId: number = 0;

  listViewCount: number = 0;

  currentListSolutionCodeIdForClient: number = 0;

  sortOrderByType: string = 'DESC';
  sortOrderByTypeForClient: string = 'DESC';

  engagementCardViewFilterModel: EngagementCardViewFilterModel;
  engagementListViewFilterModel: EngagementListViewFilterModel;

  engagementCardViewForClientFilterModel: EngagementCardViewForClientFilterModel;
  engagementListViewForClientFilterModel: EngagementListViewForClientFilterModel;

  isListFlag: boolean = false;
  isClientEngagements: boolean = false;
  userPreferenceData: UserPreferenceData[];
  engagementUserPreference: UserPreferenceData = null;
  clientdetailUserPreference: UserPreferenceData = null;
  dashBoardViewtypeName: string = 'Card';
  isQualityUserLoggedIn: boolean = false;
  isCardViewApplyResetButtonClicked: boolean = false;
  isListViewApplyResetButtonClicked: boolean = false;
  isCardViewSortApplyResetButtonClicked: boolean = false;
  isClientCardViewApplyResetButtonClicked: boolean = false;
  isClientListViewApplyResetButtonClicked: boolean = false;
  isClientCardViewSortApplyResetButtonClicked: boolean = false;
  shortcutThreshold: number = 15;
  userDetails: UserDetails = new UserDetails();
  engagementKpiDashboardDataModel: KpiMaster[];
  isKpiClickedMap: { [key: string]: boolean } = {}; // To track clicked state per KPI
  isKPISelected = false;
  selectedKPI: KpiMaster;

  public get EngagementStatus(): typeof EngagementStatus {
    return EngagementStatus;
  }

  changeOrderHistoryList: ChangeOrderModel[];
  @Output() passLoading = new EventEmitter<string>();

  //multi select filter variable declarations
  clientHeader: string = "engagementClient";
  solutionCodeHeader: string = "engagementSolutionCode";
  eppmdHeader: string = "engagementEPPMD";
  industryHeader: string = "engagementIndustry";
  engagementStatusHeader: string = "engagementStatus";
  clientIds = [];
  industryIds = [];
  eppmdIds = [];
  solutionCodeIds = [];
  engagementStatusIds = [];
  optionLabelClientName: string = "clientId";
  optionValueClientName: string = "clientName";
  optionLabelIndustryName: string = "industryTypeId";
  optionValueIndustryName: string = "industryTypeName";
  optionLabelEngagementStatus: string = "engagementStatusId";
  optionValueEngagementStatus: string = "engagementStatusName";
  optionLabelEPPMD: string = "eppmdEmail";
  optionValueEPPMD: string = "eppmdName";
  optionLabelSolutionCode: string = "solutionCodeId";
  optionValueSolutionCode: string = "solutionCodeName";
  optionHeaderClientName = "Select client";
  optionHeaderIndustryName = "Select industry";
  optionHeaderEngagementStatusName = "Select engegement status";
  optionHeaderEPPMDName = "Select EPPMD";
  optionHeaderSolutionCodeName = "Select solution code";

  // CLient Details Multi Select Filter
  optionHeaderClientDetailsIndustryName = "Select industry";
  optionHeaderClientDetailsEngagementStatusName = "Select engegement status";
  optionHeaderClientDetailsEPPMDName = "Select EPPMD";
  optionHeaderClientDetailsSolutionCodeName = "Select solution code";
  clientDetailsIndustryIds = [];
  clientDetailsEPPMDSIds = [];
  clientDetailsSolutionCodeIds = [];
  clientDetailsEngagementStatusIds = [];
  optionLabelClientDetailsIndustryName: string = "industryTypeId";
  optionValueClientDetailsIndustryName: string = "industryTypeName";
  optionLabelClientDetailsEngagementStatus: string = "engagementStatusId";
  optionValueClientDetailsEngagementStatus: string = "engagementStatusName";
  optionLabelClientDetailsEPPMD: string = "eppmdEmail";
  optionValueClientDetailsEPPMD: string = "eppmdName";
  optionLabelClientDetailsSolutionCode: string = "solutionCodeId";
  optionValueClientDetailsSolutionCode: string = "solutionCodeName";

  clientDetailsEngagementStatusHeader: string = "clientDetailsengagementStatus";
  clientDetailsSolutionCodeHeader: string = "clientDetailsSolutionCode";
  clientDetailsEPPMDHeader: string = "clientDetailsengagementEPPMD";
  clientDetailsIndustryHeader: string = "clientDetailsengagementIndustry";

  constructor(private engService: EngagementService, private route: Router,
    private loadingService: LoadingScreenService, private pagerService: PagerService,
    private changeOrderService: ChangeOrderService,
    private router: Router,
    private sharedService: SharedService,
    private kpiService: KpiService) {
    const IShortcutCount = localStorage.getItem('iShortcutCount');
    this.iShortcutCount = JSON.parse(IShortcutCount);
    const jsonString = localStorage.getItem('currentUser');
    this.userObject = JSON.parse(jsonString);
    var userPreferenceString = localStorage.getItem('userpreferencelist');
    this.userPreferenceData = userPreferenceString ? JSON.parse(userPreferenceString) : [];
    console.log(this.userPreferenceData);
    if (this.userPreferenceData && this.userPreferenceData.length > 0) {
      this.userPreferenceData.forEach(value => {
        if (value.dashBoardName === "MyEngagements") {
          this.engagementUserPreference = value;
        }
        if (value.dashBoardName === "ClientDetails") {
          this.clientdetailUserPreference = value;
        }
      });
    }
    this.DataMessage = 'Loading...';
    this.listDataMessage = 'Loading...';
    this.ClientMappedValue = 'ClientMappedValue';
    this.ClientListMappedValue = 'ClientListMappedValue';
    let nameJSON = JSON.parse(localStorage.getItem("currentUser"));
    if (nameJSON != null) {
      this.userName = nameJSON.userName;
    }
  }

  // Returns the create-client route when the client's onboarding is incomplete
  // (and a region is set); otherwise falls back to the item's normal destination.
  getNameNavRoute(list: EngagementList, defaultCommands: any[]): any[] {
    if (list != null && list.clientRegion != null && list.isClientOnboardingComplete === false) {
      return ['/NewClient/', list.clientId];
    }
    return defaultCommands;
  }

  // -- Pager service -- */
  // array of all items to be paged
  private allItems: any[];
  // pager object
  pager: any = {};
  cardViewPager: any = {};
  // paged items
  pagedItems: any[];
  // -- Pager service End-- */

  ngOnInit() {
    if (this.route.url.indexOf('ClientDetails') !== -1) {
      this.isMyEngagementLevel = true;
      const urlElement = this.route.url.split('/');
      this.passedClientId = +urlElement[urlElement.length - 1];
      //this.ShowClientName = false;
    }
    else {
      this.isMyEngagementLevel = false;
    }
    this.IsLoggedinUserSystemAdmin();
    this.engagementCardViewFilterModel = new EngagementCardViewFilterModel([], [], [], [], [], false, false, false, false, false, true, this.userName, 0);
    this.engagementListViewFilterModel = new EngagementListViewFilterModel([], [], [], [], [], false, false, false, false, false, false, this.userName, 0);
    this.engagementCardViewForClientFilterModel = new EngagementCardViewForClientFilterModel([], [], [], [], false, false, false, false, true, this.userName);
    if (this.userPreferenceData.length > 0 && this.engagementUserPreference != null && this.passedClientId <= 0) {
      this.engagementCardViewFilterModel = JSON.parse(this.engagementUserPreference.cardViewFilterList);
      this.sortOrderByType = JSON.parse(this.engagementUserPreference.cardViewSortingList).orderByType;
      if (this.sortOrderByType == undefined || this.sortOrderByType == null) {
        this.sortOrderByType = 'DESC';
      }
      this.engagementListViewFilterModel = JSON.parse(this.engagementUserPreference.listViewFilterList);
      this.orderByColumn = JSON.parse(this.engagementUserPreference.listViewSortingList).orderByColumn;
      this.cardViewnoOfrecordsPerPage = this.engagementUserPreference.cardViewPageNumber;
      if (this.cardViewnoOfrecordsPerPage == undefined || this.cardViewnoOfrecordsPerPage == null) {
        this.cardViewnoOfrecordsPerPage = 20;
      }
      this.listViewnoOfrecordsPerPage = this.engagementUserPreference.listViewPageNumber;
      if (this.listViewnoOfrecordsPerPage == undefined || this.listViewnoOfrecordsPerPage == null) {
        this.listViewnoOfrecordsPerPage = 20;
      }
      this.orderByType = JSON.parse(this.engagementUserPreference.listViewSortingList).orderByType;
      this.dashBoardViewtypeName = this.engagementUserPreference.dashboardViewType;
      if (this.dashBoardViewtypeName == undefined || this.dashBoardViewtypeName == null) {
        this.dashBoardViewtypeName = 'Card';
      }
    }
    this.engagementCardViewForClientFilterModel = new EngagementCardViewForClientFilterModel([], [], [], [], false, false, false, false, true, this.userName);
    this.engagementListViewForClientFilterModel = new EngagementListViewForClientFilterModel([], [], [], [], false, false, false, false, false, this.userName);
    if (this.userPreferenceData.length > 0 && this.clientdetailUserPreference != null && this.passedClientId > 0) {
      this.engagementCardViewForClientFilterModel = JSON.parse(this.clientdetailUserPreference.cardViewFilterList);
      this.sortOrderByTypeForClient = JSON.parse(this.clientdetailUserPreference.cardViewSortingList).sortOrderByTypeForClient;
      if (this.sortOrderByTypeForClient == undefined || this.sortOrderByTypeForClient == null) {
        this.sortOrderByTypeForClient = 'DESC';
      }
      this.engagementListViewForClientFilterModel = JSON.parse(this.clientdetailUserPreference.listViewFilterList);
      this.orderByColumn = JSON.parse(this.clientdetailUserPreference.listViewSortingList).orderByColumn;
      this.cardViewnoOfrecordsPerPage = this.clientdetailUserPreference.cardViewPageNumber;
      if (this.cardViewnoOfrecordsPerPage == undefined || this.cardViewnoOfrecordsPerPage == null) {
        this.cardViewnoOfrecordsPerPage = 20;
      }
      this.listViewnoOfrecordsPerPage = this.clientdetailUserPreference.listViewPageNumber;
      if (this.listViewnoOfrecordsPerPage == undefined || this.listViewnoOfrecordsPerPage == null) {
        this.listViewnoOfrecordsPerPage = 20;
      }
      this.orderByType = JSON.parse(this.clientdetailUserPreference.listViewSortingList).orderByType;
      this.dashBoardViewtypeName = this.clientdetailUserPreference.dashboardViewType;
      if (this.dashBoardViewtypeName == undefined || this.dashBoardViewtypeName == null) {
        this.dashBoardViewtypeName = 'Card';
      }
    }
    this.assignCheckBoxExistingFilterValue(this.userPreferenceData);
    this.setPageRecordRange();
    this.setDefaultInitialization();
    this.LoadListViewHeaders();
    var contactPopup = $('#contact-popup');
    contactPopup.hide();

    if (this.route.url.indexOf('ClientDetails') !== -1) {
      this.isMyEngagementLevel = true;
      //this.getEngagementListByClient(this.passedClientId);
      this.GetMyEngagementUniqueDataByClientId(this.passedClientId);
    } else {
      this.isMyEngagementLevel = false;
    }
    this.GetEngagementFilterSectionUniqueData();
    this.isClientEngagements = this.route.url.indexOf('ClientDetails') !== -1;
    if (this.dashBoardViewtypeName === 'Card') {
      setTimeout(() => {
        this.SetUserPreferenceCardDropDownListValues();
      }, 500);
    }
    if (this.dashBoardViewtypeName === 'List') {
      this.SetUserPreferenceListDropDownListValues();
    }
    this.getEngagementKpiDashboardDataByUser();
  }


  SetUserPreferenceCardDropDownListValues() {
    $('.Eng-CardView-Div').show();
    $('.Eng-ListView-Div').hide();
    if (this.passedClientId > 0) {
      this.getMyEngagementCountByClientId('OnInit', this.passedClientId);
      if (this.engagementCardViewForClientFilterModel.solutionCodeId.length > 0 || this.engagementCardViewForClientFilterModel.industryTypeId.length > 0 ||
        this.engagementCardViewForClientFilterModel.engagementStatusId.length > 0 || this.engagementCardViewForClientFilterModel.eppmdEmail.length > 0) {
        $("#filterEngagementCardView").addClass("partialActive");
      }
      if (this.engagementCardViewForClientFilterModel.sortSolutionCodeId || this.engagementCardViewForClientFilterModel.sortIndustryTypeId ||
        this.engagementCardViewForClientFilterModel.sortEngagementStatusId || this.engagementCardViewForClientFilterModel.sortEppmdEmailId || this.engagementCardViewForClientFilterModel.sortLastActivityDate) {
        $("#sortEngagementCardView").addClass("partialActive");
      }



    } else {
      this.engagementListViewFilterModel.kpiId = 0;
      this.getMyEngagementByUserCount('OnInit');
      if (this.engagementCardViewFilterModel.clientId.length > 0 || this.engagementCardViewFilterModel.solutionCodeId.length > 0 || this.engagementCardViewFilterModel.industryTypeId.length > 0 ||
        this.engagementCardViewFilterModel.engagementStatusId.length > 0 || this.engagementCardViewFilterModel.eppmdEmail.length > 0) {
        $("#filterEngagementCardView").addClass("partialActive");
      }
      if (this.engagementCardViewFilterModel.sortClientId || this.engagementCardViewFilterModel.sortSolutionCodeId || this.engagementCardViewFilterModel.sortIndustryTypeId ||
        this.engagementCardViewFilterModel.sortEngagementStatusId || this.engagementCardViewFilterModel.sortEppmdEmailId || this.engagementCardViewFilterModel.sortLastActivityDate) {
        $("#sortEngagementCardView").addClass("partialActive");
      }

    }



  }
  SetUserPreferenceListDropDownListValues() {
    $('.Eng-CardView-Div').hide();
    $('.Eng-ListView-Div').show();
    if (this.passedClientId > 0) {
      this.getMyEngagementListCountByClientId('OnInit', this.passedClientId);
      if (this.engagementListViewForClientFilterModel.solutionCodeId.length > 0 || this.engagementListViewForClientFilterModel.industryTypeId.length > 0 ||
        this.engagementListViewForClientFilterModel.engagementStatusId.length > 0 || this.engagementListViewForClientFilterModel.eppmdEmail.length > 0) {
        $("#filterEngagementListView").addClass("partialActive");
      }


    } else {
      this.engagementListViewFilterModel.kpiId = 0;
      this.getMyEngagementListByUserCount();
      if (this.engagementListViewFilterModel.clientId.length > 0 || this.engagementListViewFilterModel.solutionCodeId.length > 0 || this.engagementListViewFilterModel.industryTypeId.length > 0 ||
        this.engagementListViewFilterModel.engagementStatusId.length > 0 || this.engagementListViewFilterModel.eppmdEmail.length > 0) {
        $("#filterEngagementListView").addClass("partialActive");
      }

    }


  }

  GetEngagementFilterSectionUniqueData() {
    this.engService.GetEngagementFilterSectionUniqueData(this.isloggedInUserAdmin).subscribe(
      result => {
        this.engagementFilterUniqueDataList = result;
        this.clientsList = this.engagementFilterUniqueDataList.clientsList;
        this.clientsList = this.addExtaValueAll("engagementClient", this.clientsList);
        this.solutionCodeList = this.engagementFilterUniqueDataList.solutionCodeList;
        this.solutionCodeList = this.addExtaValueAll("engagementSolutionCode", this.solutionCodeList);
        this.eppmdList = this.engagementFilterUniqueDataList.eppmdList;
        this.eppmdList = this.addExtaValueAll("engagementEPPMD", this.eppmdList);
        this.industryList = this.engagementFilterUniqueDataList.industryList;
        this.industryList = this.addExtaValueAll("engagementIndustry", this.industryList);
        this.engagementStatusList = this.engagementFilterUniqueDataList.engagementStatusList;
        this.engagementStatusList = this.addExtaValueAll("engagementStatus", this.engagementStatusList);
      },
      error => {
      }
    );
  }

  GetMyEngagementUniqueDataByClientId(clientId: number) {
    this.engService.GetMyEngagementUniqueDataByClientId(this.isloggedInUserAdmin, clientId).subscribe(
      result => {
        this.engagementFilterUniqueDataByClientIdList = result;
        this.solutionCodeListForClient = this.engagementFilterUniqueDataByClientIdList.solutionCodeList;
        this.solutionCodeListForClient = this.addExtaValueAll("clientDetailsSolutionCode", this.solutionCodeListForClient);
        this.eppmdListForClient = this.engagementFilterUniqueDataByClientIdList.eppmdList;
        this.eppmdListForClient = this.addExtaValueAll("clientDetailsEPPMD", this.eppmdListForClient);
        this.industryListForClient = this.engagementFilterUniqueDataByClientIdList.industryList;
        this.industryListForClient = this.addExtaValueAll("clientDetailsIndustry", this.industryListForClient);
        this.engagementStatusListForClient = this.engagementFilterUniqueDataByClientIdList.engagementStatusList;
        this.engagementStatusListForClient = this.addExtaValueAll("clientDetailsEngagementStatus", this.engagementStatusListForClient);
      },
      error => {
      }
    );
  }
  ShowAllEngagementsWithNoFilters(paramView: string) {
    if (this.selectedKPI != undefined) {
      this.resetKPISelection(this.selectedKPI.kpiId);
    }
    this.cardViewCurrentPageNumber = 1;
    this.listViewCurrentPageNumber = 1;
    const CardViewkpiId = this.engagementCardViewFilterModel.kpiId;
    const ListViewkpiId = this.engagementListViewFilterModel.kpiId;
    if (CardViewkpiId) {
      this.engagementCardViewFilterModel.kpiId = 0;
      $("#kpi_" + CardViewkpiId).removeClass('kpi-active');
    }
    if (ListViewkpiId) {
      this.engagementListViewFilterModel.kpiId = 0
      $("#kpi_" + ListViewkpiId).removeClass('kpi-active');
    }
    if (paramView == "CardView") {
      if (this.passedClientId > 0) {
        this.setDefaultInitialization();
        this.ClearCardViewFilterFieldsForClient();
        this.ClearCardViewSortFieldsForClientView();
        this.getMyEngagementCountByClientId('OnInit', this.passedClientId);
        $("#filterEngagementCardView").removeClass("active");
        $("#sortEngagementCardView").removeClass("active");
        $("#showAllEngagementCardView").addClass("active");
        if (!(this.engagementCardViewForClientFilterModel.solutionCodeId.length > 0 || this.engagementCardViewForClientFilterModel.industryTypeId.length > 0 ||
          this.engagementCardViewForClientFilterModel.engagementStatusId.length > 0 || this.engagementCardViewForClientFilterModel.eppmdEmail.length > 0)) {
          $("#filterEngagementCardView").removeClass("partialActive");
        }
        if (!(this.engagementCardViewForClientFilterModel.sortSolutionCodeId || this.engagementCardViewForClientFilterModel.sortIndustryTypeId ||
          this.engagementCardViewForClientFilterModel.sortEngagementStatusId || this.engagementCardViewForClientFilterModel.sortEppmdEmailId || this.engagementCardViewForClientFilterModel.sortLastActivityDate)) {
          $("#sortEngagementCardView").removeClass("partialActive");
        }
        this.InsertUpdateUserPreferenceData();
      }
      else {
        this.setDefaultInitialization();
        this.ClearCardViewFilterFields();
        this.ClearCardViewSortFields();
        this.InsertUpdateUserPreferenceData();
        this.getMyEngagementByUserCount('ShowAll');
        $("#filterEngagementCardView").removeClass("active");
        $("#sortEngagementCardView").removeClass("active");
        $("#showAllEngagementCardView").addClass("active");
        if (!(this.engagementCardViewFilterModel.clientId.length > 0 || this.engagementCardViewFilterModel.solutionCodeId.length > 0 || this.engagementCardViewFilterModel.industryTypeId.length > 0 ||
          this.engagementCardViewFilterModel.engagementStatusId.length > 0 || this.engagementCardViewFilterModel.eppmdEmail.length > 0)) {
          $("#filterEngagementCardView").removeClass("partialActive");
        }
        if (!(this.engagementCardViewFilterModel.sortClientId || this.engagementCardViewFilterModel.sortSolutionCodeId || this.engagementCardViewFilterModel.sortIndustryTypeId ||
          this.engagementCardViewFilterModel.sortEngagementStatusId || this.engagementCardViewFilterModel.sortEppmdEmailId || this.engagementCardViewFilterModel.sortLastActivityDate)) {
          $("#sortEngagementCardView").removeClass("partialActive");
        }

      }
    }
    if (paramView == "ListView") {
      if (this.passedClientId > 0) {
        this.setDefaultInitialization();
        this.ClearListViewFilterFieldsForClient();
        this.getMyEngagementListCountByClientId('OnInit', this.passedClientId);
        $("#filterEngagementListView").removeClass("active");
        if (!(this.engagementListViewForClientFilterModel.solutionCodeId.length > 0 || this.engagementListViewForClientFilterModel.industryTypeId.length > 0 ||
          this.engagementListViewForClientFilterModel.engagementStatusId.length > 0 || this.engagementListViewForClientFilterModel.eppmdEmail.length > 0)) {
          $("#filterEngagementListView").removeClass("partialActive");
        }
        $("#showAllEngagementListView").addClass("active");
        this.InsertUpdateUserPreferenceData();
      }
      else {
        this.setDefaultInitialization();
        this.ClearListViewFilterFields();
        this.LoadListViewHeaders();
        this.InsertUpdateUserPreferenceData();
        this.getMyEngagementListByUserCount();
        $("#filterEngagementListView").removeClass("active");
        if (!(this.engagementListViewFilterModel.clientId.length > 0 || this.engagementListViewFilterModel.solutionCodeId.length > 0 || this.engagementListViewForClientFilterModel.industryTypeId.length > 0 ||
          this.engagementListViewForClientFilterModel.engagementStatusId.length > 0 || this.engagementListViewForClientFilterModel.eppmdEmail.length > 0)) {
          $("#filterEngagementListView").removeClass("partialActive");
        }
        $("#showAllEngagementListView").addClass("active");

      }
    }
    this.assignCheckBoxExistingFilterValue(this.userPreferenceData);
  }

  GetAllEngagementsByFiltersForClient() {
    this.assignFilterValuestoClientDetailsModal();
    this.isClientCardViewApplyResetButtonClicked = true;
    this.cardViewCurrentPageNumber = 1;
    this.getMyEngagementCountByClientId('ApplyClick', this.passedClientId);
    $("#filterEngagementCardView").removeClass("active");
    if (this.engagementCardViewForClientFilterModel.solutionCodeId.length > 0 || this.engagementCardViewForClientFilterModel.industryTypeId.length > 0 ||
      this.engagementCardViewForClientFilterModel.engagementStatusId.length > 0 || this.engagementCardViewForClientFilterModel.eppmdEmail.length > 0) {
      $("#filterEngagementCardView").addClass("partialActive");
    }
    if (this.engagementCardViewForClientFilterModel.sortSolutionCodeId || this.engagementCardViewForClientFilterModel.sortIndustryTypeId ||
      this.engagementCardViewForClientFilterModel.sortEngagementStatusId || this.engagementCardViewForClientFilterModel.sortEppmdEmailId || this.engagementCardViewForClientFilterModel.sortLastActivityDate) {
      $("#sortEngagementCardView").addClass("partialActive");
    }

    this.InsertUpdateUserPreferenceData();
    $('#cardViewFilterSectionForMyClient').hide();
  }

  GetAllEngagementsListByFiltersForClientView() {
    this.isClientListViewApplyResetButtonClicked = true;
    this.listViewCurrentPageNumber = 1;
    this.assignFilterValuestoClientDetailsDataModal();
    this.InsertUpdateUserPreferenceData();
    this.getMyEngagementListCountByClientId('ApplyClick', this.passedClientId);
    $("#filterEngagementListView").removeClass("active");
    if (this.engagementListViewForClientFilterModel.solutionCodeId.length > 0 || this.engagementListViewForClientFilterModel.industryTypeId.length > 0 ||
      this.engagementListViewForClientFilterModel.engagementStatusId.length > 0 || this.engagementListViewForClientFilterModel.eppmdEmail.length > 0) {
      $("#filterEngagementListView").addClass("partialActive");
    }


    $('#listViewFilterSectionForClient').hide();
  }

  GetAllEngagementsByFilters() {
    if (this.selectedKPI != undefined) {
      this.resetKPISelection(this.selectedKPI.kpiId);
    }
    this.assignFilterValuestoModal();
    this.isCardViewApplyResetButtonClicked = true;
    this.cardViewCurrentPageNumber = 1;
    this.engagementListViewFilterModel.kpiId = 0;
    this.getMyEngagementByUserCount('ApplyClick');
    $("#filterEngagementCardView").removeClass("active");
    if (this.engagementCardViewFilterModel.clientId.length > 0 || this.engagementCardViewFilterModel.solutionCodeId.length > 0 || this.engagementCardViewFilterModel.industryTypeId.length > 0 ||
      this.engagementCardViewFilterModel.engagementStatusId.length > 0 || this.engagementCardViewFilterModel.eppmdEmail.length > 0) {
      $("#filterEngagementCardView").addClass("partialActive");
    }

    this.InsertUpdateUserPreferenceData();
    $('#cardViewFilterSection').hide();
  }
  GetAllSortedEngagementsByFilters() {
    this.isKpiClickedMap = {};
    if (this.selectedKPI != undefined) {
      this.resetKPISelection(this.selectedKPI.kpiId);
    }
    this.isCardViewSortApplyResetButtonClicked = true;
    this.sortOrderByType = $('#ddListOrderByType').val();
    this.cardViewCurrentPageNumber = 1;
    this.engagementCardViewFilterModel.kpiId = 0;
    this.getMyEngagementByUserCount('ApplyClick');
    $("#sortEngagementCardView").removeClass("active");
    if (this.engagementCardViewFilterModel.sortClientId || this.engagementCardViewFilterModel.sortSolutionCodeId || this.engagementCardViewFilterModel.sortIndustryTypeId ||
      this.engagementCardViewFilterModel.sortEngagementStatusId || this.engagementCardViewFilterModel.sortEppmdEmailId || this.engagementCardViewFilterModel.sortLastActivityDate) {
      $("#sortEngagementCardView").addClass("partialActive");
    }
    this.InsertUpdateUserPreferenceData();
    $('#cardViewSortSection').hide();
  }

  onReset_GetAllSortedEngagementsByFilters() {
    this.sortOrderByType = $('#ddListOrderByType').val();
    this.cardViewCurrentPageNumber = 1;
    this.getMyEngagementByUserCount('ApplyClick');
  }
  GetAllSortedEngagementsByFiltersForClient() {
    this.isClientCardViewSortApplyResetButtonClicked = true;
    this.sortOrderByTypeForClient = $('#ddListOrderByTypeForClient').val();
    this.cardViewCurrentPageNumber = 1;
    this.getMyEngagementCountByClientId('ApplyClick', this.passedClientId);
    $("#sortEngagementCardView").removeClass("active");
    if (this.engagementCardViewForClientFilterModel.solutionCodeId.length > 0 || this.engagementCardViewForClientFilterModel.industryTypeId.length > 0 ||
      this.engagementCardViewForClientFilterModel.engagementStatusId.length > 0 || this.engagementCardViewForClientFilterModel.eppmdEmail.length > 0) {
      $("#filterEngagementCardView").addClass("partialActive");
    }
    if (this.engagementCardViewForClientFilterModel.sortSolutionCodeId || this.engagementCardViewForClientFilterModel.sortIndustryTypeId ||
      this.engagementCardViewForClientFilterModel.sortEngagementStatusId || this.engagementCardViewForClientFilterModel.sortEppmdEmailId || this.engagementCardViewForClientFilterModel.sortLastActivityDate) {
      $("#sortEngagementCardView").addClass("partialActive");
    }
    this.InsertUpdateUserPreferenceData();
    $('#cardViewSortSectionForClient').hide();
  }

  GetAllEngagementsListByFilters() {
    this.isKpiClickedMap = {};
    if (this.selectedKPI != undefined) {
      this.resetKPISelection(this.selectedKPI.kpiId);
    }
    this.assignFilterValuestoModal();
    this.isListViewApplyResetButtonClicked = true;
    this.listViewCurrentPageNumber = 1;
    this.engagementListViewFilterModel.kpiId = 0;
    this.getMyEngagementListByUserCount();
    $("#filterEngagementListView").removeClass("active");
    if (this.engagementListViewFilterModel.clientId.length > 0 || this.engagementListViewFilterModel.solutionCodeId.length > 0 || this.engagementListViewFilterModel.industryTypeId.length > 0 ||
      this.engagementListViewFilterModel.engagementStatusId.length > 0 || this.engagementListViewFilterModel.eppmdEmail.length > 0) {
      $("#filterEngagementListView").addClass("partialActive");
    }
    this.InsertUpdateUserPreferenceData();
    $('#listViewFilterSection').hide();
  }

  ShowHideFilterPanel(SelectedView: string,) {
    switch (SelectedView) {
      case 'Show':
        if (this.passedClientId > 0) {
          this.isClientCardViewApplyResetButtonClicked = false;
          $('#cardViewFilterSectionForMyClient').show();
          $('#cardViewSortSectionForClient').hide();
          $("#filterEngagementCardView").addClass("active");
          $("#sortEngagementCardView").removeClass("active");
          $("#showAllEngagementCardView").removeClass("active");
        }
        else {
          this.isCardViewApplyResetButtonClicked = false;
          $('#cardViewFilterSection').show();
          $('#cardViewSortSection').hide();
          $("#filterEngagementCardView").addClass("active");
          $("#sortEngagementCardView").removeClass("active");
          $("#showAllEngagementCardView").removeClass("active");
        }
        break;
      case 'Hide':
        if (this.passedClientId > 0) {
          this.isCardViewApplyResetButtonClicked = false;
          $('#cardViewFilterSectionForMyClient').hide();
          $('#cardViewSortSection').hide();
          $("#filterEngagementCardView").removeClass("active");
          $("#sortEngagementCardView").removeClass("active");
          $("#showAllEngagementCardView").removeClass("active");
        }
        else {
          $('#cardViewFilterSection').hide();
          $('#cardViewSortSection').hide();
          $("#filterEngagementCardView").removeClass("active");
          $("#sortEngagementCardView").removeClass("active");
          $("#showAllEngagementCardView").removeClass("active");
        }
        break;
      case 'HideWithCancel':
        if (this.passedClientId > 0) {
          $('#cardViewFilterSectionForMyClient').hide();
          $('#cardViewSortSection').hide();
          this.ClearCardViewFilterFieldsForClient();
          this.getMyEngagementCountByClientId('ApplyClick', this.passedClientId);
          $("#filterEngagementCardView").removeClass("active");
          $("#sortEngagementCardView").removeClass("active");
          $("#showAllEngagementCardView").removeClass("active");
        }
        else {
          this.ClearCardViewFilterFields();
          $('#cardViewFilterSection').hide();
          $('#cardViewSortSection').hide();
          this.getMyEngagementByUserCount('OnInit');
          $("#filterEngagementCardView").removeClass("active");
          $("#sortEngagementCardView").removeClass("active");
          $("#showAllEngagementCardView").removeClass("active");

        }
        break;
      case 'Reset':
        this.resetFilterValuesCheckBox();
        this.sharedService.subject.next('reset');
        if (this.passedClientId > 0) {
          this.isClientCardViewApplyResetButtonClicked = true;
          this.ResetCardViewFilterFieldsForClient();
          if (!(this.engagementCardViewForClientFilterModel.solutionCodeId.length > 0 || this.engagementCardViewForClientFilterModel.industryTypeId.length > 0 ||
            this.engagementCardViewForClientFilterModel.engagementStatusId.length > 0 || this.engagementCardViewForClientFilterModel.eppmdEmail.length > 0)) {
            $("#filterEngagementCardView").removeClass("partialActive");
          }
          this.InsertUpdateUserPreferenceData();
          this.getMyEngagementCountByClientId('ApplyClick', this.passedClientId);
        }
        else {
          this.isCardViewApplyResetButtonClicked = true;
          this.ResetCardViewFilterFields();
          if (!(this.engagementCardViewFilterModel.clientId.length > 0 || this.engagementCardViewFilterModel.solutionCodeId.length > 0 || this.engagementCardViewFilterModel.industryTypeId.length > 0 ||
            this.engagementCardViewFilterModel.engagementStatusId.length > 0 || this.engagementCardViewFilterModel.eppmdEmail.length > 0)) {
            $("#filterEngagementCardView").removeClass("partialActive");
          }
          if (this.selectedKPI != undefined) {
            $("#kpi_" + this.selectedKPI.kpiId).removeClass('kpi-active');
            this.selectedKPI = new KpiMaster;
          }
          this.isKpiClickedMap = {};
          this.InsertUpdateUserPreferenceData();
          this.getMyEngagementByUserCount('OnInit');
        }
        break;
      default:
        $('#cardViewFilterSection').hide();
        $("#filterEngagementCardView").removeClass("active");
        $("#sortEngagementCardView").removeClass("active");
        $("#showAllEngagementCardView").removeClass("active");

        break;
    }
  }

  ShowHideListFilterPanel(SelectedView: string) {
    switch (SelectedView) {
      case 'Show':
        if (this.passedClientId > 0) {
          this.isClientListViewApplyResetButtonClicked = false;
          $('#listViewFilterSectionForClient').show();
          $('#listViewFilterSection').hide();
          $("#filterEngagementListView").addClass("active");
          $("#showAllEngagementListView").removeClass("active");

        }
        else {
          this.isListViewApplyResetButtonClicked = false;
          $('#listViewFilterSection').show();
          $("#filterEngagementListView").addClass("active");
          $("#showAllEngagementListView").removeClass("active");

        }
        break;
      case 'Hide':
        if (this.passedClientId > 0) {
          this.isClientListViewApplyResetButtonClicked = false;
          $('#listViewFilterSectionForClient').hide();
          $('#listViewFilterSection').hide();
          $("#filterEngagementListView").removeClass("active");
          $("#showAllEngagementListView").removeClass("active");


        }
        else {
          this.isListViewApplyResetButtonClicked = false;
          $('#listViewFilterSection').hide();
          $("#filterEngagementListView").removeClass("active");
          $("#showAllEngagementListView").removeClass("active");

        }
        break;
      case 'HideWithCancel':
        if (this.passedClientId > 0) {
          $('#listViewFilterSectionForClient').hide();
          $('#listViewSortSection').hide();
          this.ClearListViewFilterFieldsForClient();
          this.getMyEngagementListCountByClientId('ApplyClick', this.passedClientId);
          $("#filterEngagementListView").addClass("active");
          $("#showAllEngagementListView").removeClass("active");

        }
        else {
          this.ClearListViewFilterFields();
          $('#cardViewFilterSection').hide();
          $('#cardViewSortSection').hide();
          this.getMyEngagementListByUserCount();
          $("#filterEngagementListView").removeClass("active");
          $("#showAllEngagementListView").removeClass("active");

        }
        break;
      case 'Reset':
        this.resetFilterValuesCheckBox();
        this.sharedService.subject.next('reset');
        if (this.passedClientId > 0) {
          this.isClientListViewApplyResetButtonClicked = true;
          this.ResetListViewFilterFieldsForClient();
          if (!(this.engagementListViewForClientFilterModel.solutionCodeId.length > 0 || this.engagementListViewForClientFilterModel.industryTypeId.length > 0 ||
            this.engagementListViewForClientFilterModel.engagementStatusId.length > 0 || this.engagementListViewForClientFilterModel.eppmdEmail.length > 0)) {
            $("#filterEngagementListView").removeClass("partialActive");
          }
          this.InsertUpdateUserPreferenceData();
          this.getMyEngagementListCountByClientId('ApplyClick', this.passedClientId);

        }
        else {
          this.isListViewApplyResetButtonClicked = true;
          this.ResetListViewFilterFields();
          if (!(this.engagementListViewFilterModel.clientId.length > 0 || this.engagementListViewFilterModel.solutionCodeId.length > 0 || this.engagementListViewFilterModel.industryTypeId.length > 0 ||
            this.engagementListViewFilterModel.engagementStatusId.length > 0 || this.engagementListViewFilterModel.eppmdEmail.length > 0)) {
            $("#filterEngagementListView").removeClass("partialActive");
          }
          if (this.selectedKPI != undefined) {
            $("#kpi_" + this.selectedKPI.kpiId).removeClass('kpi-active');
            this.selectedKPI = new KpiMaster;
          }
          this.isKpiClickedMap = {};
          this.InsertUpdateUserPreferenceData();
          this.getMyEngagementListByUserCount();
        }
        break;
      default:
        $('#listViewFilterSection').hide();
        $("#filterEngagementListView").removeClass("active");
        $("#showAllEngagementListView").removeClass("active");
        $("#filterEngagementCardView").removeClass("active");
        $("#showAllEngagementCardView").removeClass("active");

        break;
    }
  }

  ShowHideFilterSortPanel(SelectedView: string) {
    switch (SelectedView) {
      case 'Show':
        if (this.passedClientId > 0) {
          this.isClientCardViewSortApplyResetButtonClicked = false;
          $('#cardViewSortSectionForClient').show();
          $('#cardViewFilterSectionForMyClient').hide();
          $("#filterEngagementCardView").removeClass("active");
          $("#sortEngagementCardView").addClass("active");
          $("#showAllEngagementCardView").removeClass("active");

        }
        else {
          this.isCardViewSortApplyResetButtonClicked = false;
          $('#cardViewSortSection').show();
          $('#cardViewFilterSection').hide();
          $("#filterEngagementCardView").removeClass("active");
          $("#sortEngagementCardView").addClass("active");
          $("#showAllEngagementCardView").removeClass("active");

        }
        break;
      case 'Hide':
        if (this.passedClientId > 0) {
          this.isClientCardViewSortApplyResetButtonClicked = false;
          $('#cardViewSortSectionForClient').hide();
          $('#cardViewFilterSection').hide();
          $("#filterEngagementCardView").removeClass("active");
          $("#sortEngagementCardView").removeClass("active");
          $("#showAllEngagementCardView").removeClass("active");

        }
        else {
          this.isCardViewSortApplyResetButtonClicked = false;
          $('#cardViewSortSection').hide();
          $('#cardViewFilterSection').hide();
          $("#filterEngagementCardView").removeClass("active");
          $("#sortEngagementCardView").removeClass("active");
          $("#showAllEngagementCardView").removeClass("active");

        }
        break;
      case 'HideWithCancel':
        if (this.passedClientId > 0) {
          this.setDefaultInitialization();
          this.ClearCardViewSortFieldsForClientView();
          this.getMyEngagementCountByClientId('OnInit', this.passedClientId);
          $("#filterEngagementCardView").removeClass("active");
          $("#sortEngagementCardView").removeClass("active");
          $("#showAllEngagementCardView").removeClass("active");

        }
        else {
          this.setDefaultInitialization();
          this.ClearCardViewSortFields();
          this.getMyEngagementByUserCount('OnInit');
          $("#filterEngagementCardView").removeClass("active");
          $("#sortEngagementCardView").removeClass("active");
          $("#showAllEngagementCardView").removeClass("active");

        }
        break;
      case 'Reset':
        this.resetFilterValuesCheckBox();
        this.sharedService.subject.next('reset');
        if (this.passedClientId > 0) {
          this.isClientCardViewSortApplyResetButtonClicked = true;
          this.setDefaultInitialization();
          this.ResetCardViewSortFieldsForClientView();
          if (!(this.engagementCardViewForClientFilterModel.sortSolutionCodeId || this.engagementCardViewFilterModel.sortIndustryTypeId ||
            this.engagementCardViewForClientFilterModel.sortEngagementStatusId || this.engagementCardViewForClientFilterModel.sortEppmdEmailId || this.engagementCardViewForClientFilterModel.sortLastActivityDate)) {
            $("#sortEngagementCardView").removeClass("partialActive");
          }
          this.InsertUpdateUserPreferenceData();
          this.getMyEngagementCountByClientId('OnInit', this.passedClientId);

        }
        else {
          this.isCardViewSortApplyResetButtonClicked = true;
          this.setDefaultInitialization();
          this.ResetCardViewSortFields();
          if (!(this.engagementCardViewFilterModel.sortClientId || this.engagementCardViewFilterModel.sortSolutionCodeId || this.engagementCardViewFilterModel.sortIndustryTypeId ||
            this.engagementCardViewFilterModel.sortEngagementStatusId || this.engagementCardViewFilterModel.sortEppmdEmailId || this.engagementCardViewFilterModel.sortLastActivityDate)) {
            $("#sortEngagementCardView").removeClass("partialActive");
          }
          if (this.selectedKPI != undefined) {
            $("#kpi_" + this.selectedKPI.kpiId).removeClass('kpi-active');
            this.selectedKPI = new KpiMaster;
          }
          this.isKpiClickedMap = {};
          this.InsertUpdateUserPreferenceData();
          this.onReset_GetAllSortedEngagementsByFilters();

        }
        break;
      default:
        $('#cardViewSortSectionForClient').hide();
        $('#cardViewSortSection').hide();
        $("#filterEngagementCardView").removeClass("active");
        $("#sortEngagementCardView").removeClass("active");
        $("#showAllEngagementCardView").removeClass("active");
        break;
    }
  }
  ClearCardViewFilterFields() {
    this.engagementCardViewFilterModel = new EngagementCardViewFilterModel([], [], [], [], [], false, false, false, false, false, true, this.userName, 0);
    $('#txtValueClientMappedValue0').val("");
    $('#ddClientsForEngagementList').val(0);
    $('input:hidden').val('');
    $('#ddSolutionCodeList').val(0);
    $('#ddEppmdList').val('');
    $('#ddIndustryTypeList').val(0);
    $('#ddEngagementStatusList').val('');
    $('#cardViewFilterSection').hide();
  }

  ResetCardViewFilterFields() {
    this.engagementCardViewFilterModel = new EngagementCardViewFilterModel([], [], [], [], [], false, false, false, false, false, true, this.userName, 0);
    this.cardViewCurrentPageNumber = 1;
    $('#txtValueClientMappedValue0').val("");
    $('#ddClientsForEngagementList').val(0);
    $('input:hidden').val('');
    $('#ddSolutionCodeList').val(0);
    $('#ddEppmdList').val('');
    $('#ddIndustryTypeList').val(0);
    $('#ddEngagementStatusList').val('');
    //$('#cardViewFilterSection').hide();
  }

  ClearCardViewFilterFieldsForClient() {
    this.engagementCardViewForClientFilterModel = new EngagementCardViewForClientFilterModel([], [], [], [], false, false, false, false, false, this.userName);
    $('#ddSolutionCodeListForClient').val(0);
    $('#ddEppmdListForClient').val('');
    $('#ddIndustryTypeListForClient').val(0);
    $('#ddEngagementStatusListForClient').val('');
    $('#cardViewFilterSectionForMyClient').hide();
  }
  ResetCardViewFilterFieldsForClient() {
    this.engagementCardViewForClientFilterModel = new EngagementCardViewForClientFilterModel([], [], [], [], false, false, false, false, true, this.userName);
    this.cardViewCurrentPageNumber = 1;
    $('#ddSolutionCodeListForClient').val(0);
    $('#ddEppmdListForClient').val('');
    $('#ddIndustryTypeListForClient').val(0);
    $('#ddEngagementStatusListForClient').val('');
  }

  ClearListViewFilterFieldsForClient() {
    this.engagementListViewForClientFilterModel = new EngagementListViewForClientFilterModel([], [], [], [], false, false, false, false, false, this.userName);
    $('#ddListSolutionCodeForClientListView').val(0);
    $('#ddListEppmdForClientListView').val(0);
    $('#ddListIndustryTypeForClientListView').val(0);
    $('#ddListEngagementStatusForClientListView').val('');
    $('#listViewFilterSectionForMyClient').hide();
  }
  ResetListViewFilterFieldsForClient() {
    this.engagementListViewForClientFilterModel = new EngagementListViewForClientFilterModel([], [], [], [], false, false, false, false, false, this.userName);
    this.listViewCurrentPageNumber = 1;
    $('#ddListSolutionCodeForClientListView').val(0);
    $('#ddListEppmdForClientListView').val("");
    $('#ddListIndustryTypeForClientListView').val(0);
    $('#ddListEngagementStatusForClientListView').val('');
  }
  ClearListViewFilterFields() {
    this.engagementListViewFilterModel = new EngagementListViewFilterModel([], [], [], [], [], false, false, false, false, false, false, this.userName, 0);
    $('#txtValueClientListMappedValue0').val("");
    $('#ddListClientsForEngagement').val(0);
    $('input:hidden').val('');
    $('#ddListSolutionCode').val(0);
    $('#ddListEppmd').val('');
    $('#ddListIndustryType').val(0);
    $('#ddListEngagementStatus').val('');
    $('#listViewFilterSection').hide();
  }
  ResetListViewFilterFields() {
    this.engagementListViewFilterModel = new EngagementListViewFilterModel([], [], [], [], [], false, false, false, false, false, false, this.userName, 0);
    this.listViewCurrentPageNumber = 1;
    $('#txtValueClientListMappedValue0').val("");
    $('#ddListClientsForEngagement').val(0);
    $('input:hidden').val('');
    $('#ddListSolutionCode').val(0);
    $('#ddListEppmd').val('');
    $('#ddListIndustryType').val(0);
    $('#ddListEngagementStatus').val('');
  }
  ClearCardViewSortFields() {
    this.engagementCardViewFilterModel = new EngagementCardViewFilterModel([], [], [], [], [], false, false, false, false, false, true, this.userName, 0);
    this.resetCardViewSortCheckBox();
    $('#cardViewSortSection').hide();
    this.sortOrderByType = 'DESC';
  }

  ResetCardViewSortFields() {
    this.engagementCardViewFilterModel.sortClientId = false;
    this.engagementCardViewFilterModel.sortSolutionCodeId = false;
    this.engagementCardViewFilterModel.sortEppmdEmailId = false;
    this.engagementCardViewFilterModel.sortIndustryTypeId = false;
    this.engagementCardViewFilterModel.sortEngagementStatusId = false;
    this.engagementCardViewFilterModel.sortLastActivityDate = true;
    this.engagementCardViewFilterModel.kpiId = 0;
    this.resetCardViewSortCheckBox();
  }

  ClearCardViewSortFieldsForClientView() {
    this.engagementCardViewForClientFilterModel = new EngagementCardViewForClientFilterModel([], [], [], [], false, false, false, false, true, this.userName);
    $('#chkSolutionCodeForClient').prop('checked', false);
    $('#chkEppmdForClient').prop('checked', false);
    $('#chkIndustryTypeForClient').prop('checked', false);
    $('#chkEngagementStatusForClient').prop('checked', false);
    $('#chkLastActivityDateForClient').prop('checked', true);
    $('#cardViewSortSectionForClient').hide();
    $('#ddListOrderByTypeForClient').val('DESC');
  }

  ResetCardViewSortFieldsForClientView() {
    this.engagementCardViewForClientFilterModel.sortSolutionCodeId = false;
    this.engagementCardViewForClientFilterModel.sortEppmdEmailId = false;
    this.engagementCardViewForClientFilterModel.sortIndustryTypeId = false;
    this.engagementCardViewForClientFilterModel.sortEngagementStatusId = false;
    this.engagementCardViewForClientFilterModel.sortLastActivityDate = true;
    this.cardViewCurrentPageNumber = 1;
    $('#chkSolutionCodeForClient').prop('checked', false);
    $('#chkEppmdForClient').prop('checked', false);
    $('#chkIndustryTypeForClient').prop('checked', false);
    $('#chkEngagementStatusForClient').prop('checked', false);
    $('#chkLastActivityDateForClient').prop('checked', true);
    $('#ddListOrderByTypeForClient').val('DESC');
  }

  ngAfterViewChecked() {
    // console.log('inside ', this.applyFilterOnceAfterDataLoad);
    // Below functionality is called once data is loaded. Here ideal solution is implement promise in loading of data and apply.
    if (this.applyFilterOnceAfterDataLoad) {
      this.BindContactPopup();
      this.applyFilterOnceAfterDataLoad = false;
    }
  }


  closeContactPopupListView() {
    $('html').on('click', function (e) {
      console.log('first', $(e.target).parents().is('.popover.in'));
      console.log('second', $(e.target).data('original-title'));

      if (typeof $(e.target).data('original-title') == 'undefined' &&
        !$(e.target).parents().is('.popover.in')) {
        const id = $('#' + ContactCardClick.listViewInput).val();
        $('#ePPMDcontactPopup_' + id).popover('hide');
        console.log('xxx11', $('#ePPMDcontactPopup_' + id));
        console.log('xxx', '#' + ContactCardControl.listViewdiv + id);
      }
    });

    $('body').on('click', function (e) {
      console.log('body click event fired', $(e.target).is('.' + ContactCardControl.close));
      let target = e.target;
      let parent = target.parentElement;
      if ($(target).is('.' + ContactCardControl.close) || $(parent).is('.' + ContactCardControl.close)) {
        if ($(e.target).data('toggle') !== 'popover'
          && $(e.target).parents('.popover.in').length === 0) {
          const id = $('#' + ContactCardClick.listViewInput).val();
          $('#ePPMDcontactPopup_' + id).popover('hide');
        }
      }
    });

  }

  closeContactPopupCardView() {

    $('html').on('click', function (e) {
      if (typeof $(e.target).data('original-title') == 'undefined' &&
        !$(e.target).parents().is('.popover.in')) {
        const id = $('#cardViewtxtengId').val();
        $('#cardViewEPPMDcontactPopup_' + id).popover('hide');
      }
    });

    $('body').on('click', function (e) {
      //did not click a popover toggle or popover
      console.log('body click event fired', $(e.target).is('.contact-close'));
      let target = e.target;
      let parent = target.parentElement;
      if ($(target).is('.contact-close') || $(parent).is('.contact-close')) {
        if ($(e.target).data('toggle') !== 'popover'
          && $(e.target).parents('.popover.in').length === 0) {
          console.log('condition met');
          console.log('listViewtxtengId ==>', $('#cardViewtxtengId').val());
          const id = $('#cardViewtxtengId').val();
          $('#cardViewEPPMDcontactPopup_' + id).popover('hide');
        }
      }
    });

  }

  ngAfterViewInit() {
    this.closeContactPopupListView();
    this.closeContactPopupCardView();

  }
  initTooltip() {
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip({
        container: 'body',
        html: true
      });
    }, 1000);
  }

  setDefaultInitialization() {
    this.applyFilterOnceAfterDataLoad = false;
    this.orderByColumn = 'LastActivityDate';
    this.orderByType = 'DESC';
    if (this.userPreferenceData.length > 0 && this.engagementUserPreference != null && this.passedClientId <= 0) {
      this.orderByColumn = JSON.parse(this.engagementUserPreference.listViewSortingList).orderByColumn;
      if (this.orderByColumn == undefined || this.orderByColumn == null) {
        this.orderByColumn = 'LastActivityDate';
      }
      this.orderByType = JSON.parse(this.engagementUserPreference.listViewSortingList).orderByType;
      if (this.orderByType == undefined || this.orderByType == null) {
        this.orderByType = 'DESC';
      }
    }
    if (this.userPreferenceData.length > 0 && this.clientdetailUserPreference != null && this.passedClientId > 0) {
      this.orderByColumn = JSON.parse(this.clientdetailUserPreference.listViewSortingList).orderByColumn;
      if (this.orderByColumn == undefined || this.orderByColumn == null) {
        this.orderByColumn = 'LastActivityDate';
      }
      this.orderByType = JSON.parse(this.clientdetailUserPreference.listViewSortingList).orderByType;
      if (this.orderByType == undefined || this.orderByType == null) {
        this.orderByType = 'DESC';
      }
    }
    this.cardVieworderByColumn = 'LastActivityDate';
    this.cardVieworderByType = 'DESC';
  }

  IsLoggedinUserSystemAdmin() {
    console.log('userObject ==>', this.userObject);
    if (this.userObject != null && this.userObject.role != null && this.userObject.role.length > 0) {
      for (let i = 0; i < this.userObject.role.length; i++) {
        if (this.userObject.role[i].shortRoleName === 'SA') {
          this.isloggedInUserAdmin = 'yes';
          break;
        }
        else {
          this.isloggedInUserAdmin = 'no';
        }
        if (this.userObject.role[i].shortRoleName == 'QG') {
          this.isQualityUserLoggedIn = true;
        }
      }
    }
  }

  setPageRecordRange() {
    this.noOfrecordsPerPageList = [];
    this.noOfrecordsPerPageList.push(10);
    this.noOfrecordsPerPageList.push(20);
    this.noOfrecordsPerPageList.push(40);
    this.noOfrecordsPerPageList.push(60);
    this.noOfrecordsPerPageList.push(80);
    this.noOfrecordsPerPageList.push(100);
  }

  getMyEngagementCountByClientId(isOnInitFlag: string, clientId: number) {
    this.loadingService.startLoading();
    this.engService.getMyEngagementCountByClientId(this.engagementCardViewForClientFilterModel,
      this.isloggedInUserAdmin,
      clientId).subscribe(
        result => {
          this.engagementCountByClientId = result;
          if (isOnInitFlag == 'OnInit') {
            this.cardCount = result;
          }
          this.loadingService.stopLoading();
          if (this.engagementCountByClientId > 0) {
            // initialize to page 1
            this.cardViewSetPageByClientId(this.cardViewCurrentPageNumber, this.cardViewnoOfrecordsPerPage, clientId);
          }
          else {
            this.cardCount = 0;
            this.loadingService.stopLoading();
            this.engagementCardList = null;
            if (this.cardCount === 0) {
              this.DataMessage = ' No Data Available';
            }
          }
        },
        error => {
          this.loadingService.stopLoading();
        }
      );
  }

  getMyEngagementListCountByClientId(isOnInitFlag: string, clientId: number) {
    this.loadingService.startLoading();
    this.engService.getMyEngagementCountByClientId(this.engagementListViewForClientFilterModel,
      this.isloggedInUserAdmin,
      clientId).subscribe(
        result => {
          this.engagementListCountByClientId = result;
          this.loadingService.stopLoading();

          if (isOnInitFlag == 'OnInit') {
            this.listViewCount = result;
          }
          if (this.engagementListCountByClientId > 0) {
            // initialize to page 1
            this.listViewSetPage(this.listViewCurrentPageNumber, this.listViewnoOfrecordsPerPage);
          }
          else {
            this.listCount = 0;
            this.engagementList = null;
            if (this.listCount === 0) {
              this.listDataMessage = ' No Data Available';
            }
            this.loadingService.stopLoading();
          }
        },
        error => {
          this.loadingService.stopLoading();
        }
      );
  }

  getMyEngagementByUserCount(isOnInitFlag: string) {
    this.startLoading();
    this.engService.getMyEngagementCardViewByUserCount(this.isloggedInUserAdmin, this.engagementCardViewFilterModel).subscribe(
      result => {
        this.engagementCount = result;
        this.stopLoading();
        if (isOnInitFlag == 'OnInit') {
          this.listViewCount = result;
        }
        if (this.engagementCount > 0) {
          this.cardViewSetPage(this.cardViewCurrentPageNumber, this.cardViewnoOfrecordsPerPage);
        }
        else {
          this.cardCount = 0;
          this.engagementCardList = null;
          if (this.cardCount === 0) {
            this.DataMessage = ' No Data Available';
          }
        }
      },
      error => {
        this.stopLoading();
      }
    );
  }
  getMyEngagementListByUserCount() {
    this.startLoading();
    this.engService.getMyEngagementListViewByUserCount(this.isloggedInUserAdmin, this.engagementListViewFilterModel).subscribe(
      result => {
        this.engagementListCount = result;
        this.stopLoading();
        if (this.engagementListCount > 0) {
          this.isListFlag = true;
          this.listViewSetPage(this.listViewCurrentPageNumber, this.listViewnoOfrecordsPerPage);
        }
        else {
          this.isListFlag = false;
          this.listCount = 0;
          this.engagementList = null;
          if (this.listCount === 0) {
            this.listDataMessage = ' No Data Available';
          }
        }
      },
      error => {
        this.stopLoading();
      }
    );
  }

  listViewSetPage(pageNumber: number, recordsPerPage: number) {
    // get pager object from service this.passedClientId
    this.listViewCurrentPageNumber = pageNumber;
    const inputDrpValue = $('#drprecordsPerPage option:selected').text();
    if (inputDrpValue === '') {
      this.listViewnoOfrecordsPerPage = recordsPerPage;
    } else {
      this.listViewnoOfrecordsPerPage = Number(inputDrpValue);
    }

    this.InsertUpdateUserPreferenceData();


    if (this.listViewCurrentPageNumber != 0) {
      if (this.passedClientId > 0) {
        this.getMyEngagementListViewByClientId(this.engagementListViewForClientFilterModel,
          this.listViewCurrentPageNumber, this.listViewnoOfrecordsPerPage,
          this.orderByColumn, this.orderByType, this.passedClientId);

        this.pager = this.pagerService.getPager(this.engagementListCountByClientId,
          this.listViewCurrentPageNumber,
          this.listViewnoOfrecordsPerPage);
      }
      else {
        this.getMyEngagementListView(this.listViewCurrentPageNumber,
          this.listViewnoOfrecordsPerPage,
          this.orderByColumn, this.orderByType);
        if (this.isListFlag == true) {
          this.pager = this.pagerService.getPager(this.engagementListCount, this.listViewCurrentPageNumber, this.listViewnoOfrecordsPerPage);
        }
        else {
          this.pager = this.pagerService.getPager(this.listViewCount, this.listViewCurrentPageNumber, this.listViewnoOfrecordsPerPage);
        }
      }
      console.log('pager ==>', this.pager);
    } else {
      $('#previous').off('click');
      $('#first').off('click');
    }
  }
  cardViewSetPageByClientId(pageNumber: number, recordsPerPage: number, clientId: number) {
    // get CardViewpager object from service
    this.cardViewCurrentPageNumber = pageNumber;
    const inputDrpValue = $('#cardViewdrprecordsPerPage option:selected').text();
    if (inputDrpValue === '') {
      this.cardViewnoOfrecordsPerPage = recordsPerPage;
    } else {
      this.cardViewnoOfrecordsPerPage = Number(inputDrpValue);
    }
    if (this.cardViewCurrentPageNumber != 0) {
      if (this.sortOrderByTypeForClient != null && this.sortOrderByTypeForClient != "") {
        this.cardVieworderByType = this.sortOrderByTypeForClient;
      }
      this.getMyEngagementCardViewByClientId(this.engagementCardViewForClientFilterModel,
        this.cardViewCurrentPageNumber,
        this.cardViewnoOfrecordsPerPage,
        this.cardVieworderByColumn,
        this.cardVieworderByType, clientId);
      this.cardViewPager = this.pagerService.getPager(this.engagementCountByClientId, this.cardViewCurrentPageNumber, this.cardViewnoOfrecordsPerPage);
      console.log('cardViewPager ==>', this.cardViewPager);
    } else {
      $('#cardViewPrevious').off('click');
      $('#cardViewFirst').off('click');
    }
  }

  cardViewSetPage(pageNumber: number, recordsPerPage: number) {
    // get CardViewpager object from service
    this.cardViewCurrentPageNumber = pageNumber;
    const inputDrpValue = $('#cardViewdrprecordsPerPage option:selected').text();
    if (inputDrpValue === '') {
      this.cardViewnoOfrecordsPerPage = recordsPerPage;
    } else {
      this.cardViewnoOfrecordsPerPage = Number(inputDrpValue);
    }
    this.InsertUpdateUserPreferenceData();
    if (this.cardViewCurrentPageNumber != 0) {
      if (this.passedClientId > 0) {
        this.getMyEngagementCardViewByClientId(this.engagementCardViewForClientFilterModel,
          this.cardViewCurrentPageNumber, this.cardViewnoOfrecordsPerPage,
          this.cardVieworderByColumn, this.cardVieworderByType, this.passedClientId);
        this.cardViewPager = this.pagerService.getPager(this.engagementCountByClientId, this.cardViewCurrentPageNumber, this.cardViewnoOfrecordsPerPage);
      }
      else {
        if (this.sortOrderByType != null && this.sortOrderByType != "") {
          this.cardVieworderByType = this.sortOrderByType;
        }
        this.getMyEngagementCardView(this.cardViewCurrentPageNumber,
          this.cardViewnoOfrecordsPerPage,
          this.cardVieworderByColumn, this.cardVieworderByType);
        this.cardViewPager = this.pagerService.getPager(this.engagementCount, this.cardViewCurrentPageNumber, this.cardViewnoOfrecordsPerPage);
      }
      console.log('cardViewPager ==>', this.cardViewPager);
    } else {
      $('#cardViewPrevious').off('click');
      $('#cardViewFirst').off('click');
    }
  }

  setInitialsForListView() {
    if (this.listCount === 0) {
      this.headerModelList[0].imageModelList[0].isVisible = true;
      this.headerModelList[0].imageModelList[1].isVisible = false;
      this.headerModelList[0].imageModelList[2].isVisible = false;
    }
  }

  LoadListViewHeaders() {
    this.headerModelList = [];
    this.headerImageModelList = [];
    this.newImageModel = {
      imageName: 'DEFAULT',
      imageValue: 'ASC',
      imagePath: '../../../../assets/images/EDP/Engagement/unfold_more-24px.svg',
      isVisible: true
    };
    this.headerImageModelList.push(JSON.parse(JSON.stringify(this.newImageModel)));

    this.newImageModel = {
      imageName: 'Asending',
      imageValue: 'ASC',
      imagePath: '../../../../assets/images/EDP/Engagement/asc_order.svg',
      isVisible: false
    };
    this.headerImageModelList.push(JSON.parse(JSON.stringify(this.newImageModel)));

    this.newImageModel = {
      imageName: 'Desending',
      imageValue: 'DESC',
      imagePath: '../../../../assets/images/EDP/Engagement/desc_order.svg',
      isVisible: false
    };
    this.headerImageModelList.push(JSON.parse(JSON.stringify(this.newImageModel)));

    this.headerModel = {
      headerId: 1,
      headerName: 'Client name',
      headerValue: 'ClientName',
      headerClick: true,
      imageModelList: this.headerImageModelList
    };
    this.headerModelList.push(JSON.parse(JSON.stringify(this.headerModel)));
    if (this.orderByColumn === 'ClientName') {
      if (this.orderByType == 'ASC') {
        this.headerModelList[0].imageModelList[0].isVisible = false;
        this.headerModelList[0].imageModelList[1].isVisible = true;
        this.headerModelList[0].imageModelList[2].isVisible = false;
      }
      if (this.orderByType == 'DESC') {
        this.headerModelList[0].imageModelList[0].isVisible = false;
        this.headerModelList[0].imageModelList[1].isVisible = false;
        this.headerModelList[0].imageModelList[2].isVisible = true;
      }
    }

    this.headerModel = {
      headerId: 2,
      headerName: 'Engagement name',
      headerValue: 'EngagementName',
      headerClick: false,
      imageModelList: this.headerImageModelList
    };
    this.headerModelList.push(JSON.parse(JSON.stringify(this.headerModel)));
    if (this.orderByColumn === 'EngagementName') {
      if (this.orderByType == 'ASC') {
        this.headerModelList[1].imageModelList[0].isVisible = false;
        this.headerModelList[1].imageModelList[1].isVisible = true;
        this.headerModelList[1].imageModelList[2].isVisible = false;
      }
      if (this.orderByType == 'DESC') {
        this.headerModelList[1].imageModelList[0].isVisible = false;
        this.headerModelList[1].imageModelList[1].isVisible = false;
        this.headerModelList[1].imageModelList[2].isVisible = true;
      }
    }

    this.headerModel = {
      headerId: 3,
      headerName: 'Primary solution code',
      headerValue: 'ParentSolutionCode',
      headerClick: false,
      imageModelList: this.headerImageModelList
    };
    this.headerModelList.push(JSON.parse(JSON.stringify(this.headerModel)));
    if (this.orderByColumn === 'ParentSolutionCode') {
      if (this.orderByType == 'ASC') {
        this.headerModelList[2].imageModelList[0].isVisible = false;
        this.headerModelList[2].imageModelList[1].isVisible = true;
        this.headerModelList[2].imageModelList[2].isVisible = false;
      }
      if (this.orderByType == 'DESC') {
        this.headerModelList[2].imageModelList[0].isVisible = false;
        this.headerModelList[2].imageModelList[1].isVisible = false;
        this.headerModelList[2].imageModelList[2].isVisible = true;
      }
    }

    this.headerModel = {
      headerId: 4,
      headerName: 'EPPMD',
      headerValue: 'EPPMD',
      headerClick: false,
      imageModelList: this.headerImageModelList
    };
    this.headerModelList.push(JSON.parse(JSON.stringify(this.headerModel)));
    if (this.orderByColumn === 'EPPMD') {
      if (this.orderByType == 'ASC') {
        this.headerModelList[3].imageModelList[0].isVisible = false;
        this.headerModelList[3].imageModelList[1].isVisible = true;
        this.headerModelList[3].imageModelList[2].isVisible = false;
      }
      if (this.orderByType == 'DESC') {
        this.headerModelList[3].imageModelList[0].isVisible = false;
        this.headerModelList[3].imageModelList[1].isVisible = false;
        this.headerModelList[3].imageModelList[2].isVisible = true;
      }
    }


    this.headerModel = {
      headerId: 5,
      headerName: 'Assignments',
      headerValue: 'AssignmentsCount',
      headerClick: false,
      imageModelList: this.headerImageModelList
    };
    this.headerModelList.push(JSON.parse(JSON.stringify(this.headerModel)));
    if (this.orderByColumn === 'AssignmentsCount') {
      if (this.orderByType == 'ASC') {
        this.headerModelList[4].imageModelList[0].isVisible = false;
        this.headerModelList[4].imageModelList[1].isVisible = true;
        this.headerModelList[4].imageModelList[2].isVisible = false;
      }
      if (this.orderByType == 'DESC') {
        this.headerModelList[4].imageModelList[0].isVisible = false;
        this.headerModelList[4].imageModelList[1].isVisible = false;
        this.headerModelList[4].imageModelList[2].isVisible = true;
      }
    }

    this.headerModel = {
      headerId: 6,
      headerName: 'Last activity',
      headerValue: 'LastActivityDate',
      headerClick: false,
      imageModelList: this.headerImageModelList
    };
    this.headerModelList.push(JSON.parse(JSON.stringify(this.headerModel)));
    if (this.orderByColumn === 'LastActivityDate') {
      if (this.orderByType == 'ASC') {
        this.headerModelList[5].imageModelList[0].isVisible = false;
        this.headerModelList[5].imageModelList[1].isVisible = true;
        this.headerModelList[5].imageModelList[2].isVisible = false;
      }
      if (this.orderByType == 'DESC') {
        this.headerModelList[5].imageModelList[0].isVisible = false;
        this.headerModelList[5].imageModelList[1].isVisible = false;
        this.headerModelList[5].imageModelList[2].isVisible = true;
      }
    }

    this.headerModel = {
      headerId: 7,
      headerName: 'Status',
      headerValue: 'Status',
      headerClick: false,
      imageModelList: this.headerImageModelList
    };
    this.headerModelList.push(JSON.parse(JSON.stringify(this.headerModel)));
    if (this.orderByColumn === 'Status') {
      if (this.orderByType == 'ASC') {
        this.headerModelList[6].imageModelList[0].isVisible = false;
        this.headerModelList[6].imageModelList[1].isVisible = true;
        this.headerModelList[6].imageModelList[2].isVisible = false;
      }
      if (this.orderByType == 'DESC') {
        this.headerModelList[6].imageModelList[0].isVisible = false;
        this.headerModelList[6].imageModelList[1].isVisible = false;
        this.headerModelList[6].imageModelList[2].isVisible = true;
      }
    }

    this.headerModel = {
      headerId: 8,
      headerName: '',
      headerValue: '',
      headerClick: false,
      imageModelList: this.headerImageModelList
    };
    this.headerModelList.push(JSON.parse(JSON.stringify(this.headerModel)));

    this.headerModel = {
      headerId: 9,
      headerName: 'Indicators',
      headerValue: '',
      headerClick: false,
      imageModelList: this.headerImageModelList
    };
    this.headerModelList.push(JSON.parse(JSON.stringify(this.headerModel)));

    this.headerModel = {
      headerId: 10,
      headerName: 'Period end',
      headerValue: 'TaxYear',
      headerClick: false,
      imageModelList: this.headerImageModelList
    };

    this.headerModelList.push(JSON.parse(JSON.stringify(this.headerModel)));
    if (this.orderByColumn === 'TaxYear') {
      if (this.orderByType == 'ASC') {
        this.headerModelList[9].imageModelList[0].isVisible = false;
        this.headerModelList[9].imageModelList[1].isVisible = true;
        this.headerModelList[9].imageModelList[2].isVisible = false;
      }
      if (this.orderByType == 'DESC') {
        this.headerModelList[9].imageModelList[0].isVisible = false;
        this.headerModelList[9].imageModelList[1].isVisible = false;
        this.headerModelList[9].imageModelList[2].isVisible = true;
      }
    }

    this.headerModel = {
      headerId: 11,
      headerName: 'Change order',
      headerValue: 'ChangeOrderCOunt',
      headerClick: false,
      imageModelList: this.headerImageModelList
    };
    this.headerModelList.push(JSON.parse(JSON.stringify(this.headerModel)));
    if (this.orderByColumn === 'ChangeOrderCOunt') {
      if (this.orderByType == 'ASC') {
        this.headerModelList[10].imageModelList[0].isVisible = false;
        this.headerModelList[10].imageModelList[1].isVisible = true;
        this.headerModelList[10].imageModelList[2].isVisible = false;
      }
      if (this.orderByType == 'DESC') {
        this.headerModelList[10].imageModelList[0].isVisible = false;
        this.headerModelList[10].imageModelList[1].isVisible = false;
        this.headerModelList[10].imageModelList[2].isVisible = true;
      }
    }
    // console.log('headerModelList ==>', this.headerModelList);
  }

  HeaderSort(headerid: number) {
    for (let i = 0; i < this.headerModelList.length; i++) {
      if (this.headerModelList[i].headerId === headerid) {
        this.headerModelList[i].headerClick = true;
        if ((this.headerModelList[i].imageModelList[0].isVisible) || (this.headerModelList[i].imageModelList[2].isVisible)) {
          this.headerModelList[i].imageModelList[0].isVisible = false;
          this.headerModelList[i].imageModelList[1].isVisible = true;
          this.headerModelList[i].imageModelList[2].isVisible = false;
        } else if (this.headerModelList[i].imageModelList[1].isVisible) {
          this.headerModelList[i].imageModelList[0].isVisible = false;
          this.headerModelList[i].imageModelList[1].isVisible = false;
          this.headerModelList[i].imageModelList[2].isVisible = true;
        }
      } else {
        this.headerModelList[i].headerClick = false;
        for (let j = 0; j < this.headerModelList[i].imageModelList.length; j++) {
          this.headerModelList[i].imageModelList[0].isVisible = true;
          this.headerModelList[i].imageModelList[1].isVisible = false;
          this.headerModelList[i].imageModelList[2].isVisible = false;
        }
      }
    }

    let headerObj = this.headerModelList.find(c => c.headerClick === true);
    this.orderByColumn = headerObj.headerValue;
    for (let k = 0; k < headerObj.imageModelList.length; k++) {
      if (headerObj.imageModelList[k].isVisible === true) {
        this.orderByType = headerObj.imageModelList[k].imageValue;
        break;
      }
    }
    this.InsertUpdateUserPreferenceData();
    this.listViewSetPage(1, this.listViewnoOfrecordsPerPage);
  }

  getMyEngagementCardViewByClientId(engagementCardViewForClientFilterModel
    : EngagementCardViewForClientFilterModel,
    pageNumber: number, listViewnoOfrecordsPerPage, orderBy,
    orderType, clientId: number) {
    this.loadingService.startLoading();
    // orderBy = null;
    this.engService.getMyEngagementCardViewByClientId(engagementCardViewForClientFilterModel,
      pageNumber, listViewnoOfrecordsPerPage,
      this.isloggedInUserAdmin, orderBy, orderType, clientId).subscribe(
        result => {
          this.engagementCardList = result;
          this.initTooltip();
          console.log("engagementCardList ==>", this.engagementCardList);
          this.cardCount = this.engagementCardList.length;
          if (this.cardCount === 0) {
            this.DataMessage = ' No Data Available';
            this.loadingService.stopLoading();
          } else if (this.cardCount === null) {
            this.DataMessage = 'Loading...';
            this.loadingService.stopLoading();
          } else {
            this.DataMessage = '';
            this.loadingService.stopLoading();
          }

          this.applyFilterOnceAfterDataLoad = true;
        },
        err => {
          console.log('Error in loading the client list information.');
          this.loadingService.stopLoading();
        }
      );
  }

  getMyEngagementListViewByClientId(engagementListViewForClientFilterModel
    : EngagementListViewForClientFilterModel,
    pageNumber: number, listViewnoOfrecordsPerPage, orderBy,
    orderType, clientId: number) {
    this.loadingService.startLoading();
    this.engService.getMyEngagementListViewByClientId(engagementListViewForClientFilterModel,
      pageNumber, listViewnoOfrecordsPerPage,
      this.isloggedInUserAdmin, orderBy, orderType, clientId).subscribe(
        result => {
          this.engagementList = result;
          this.listCount = this.engagementList.length;
          if (this.listCount === 0) {
            this.listDataMessage = ' No Data Available';
            this.loadingService.stopLoading();

          } else if (this.listCount === null) {
            this.DataMessage = 'Loading...';
            this.loadingService.stopLoading();

          } else {
            this.listDataMessage = '';
            this.loadingService.stopLoading();

          }

          this.applyFilterOnceAfterDataLoad = true;
        },
        err => {
          console.log('Error in loading the client list information.');
          this.loadingService.stopLoading();

        }
      );
  }

  getMyEngagementCardView(pageNumber: number,
    listViewnoOfrecordsPerPage, orderBy, orderType) {
    this.startLoading();
    this.engService.getMyEngagementCardView(this.engagementCardViewFilterModel, pageNumber,
      listViewnoOfrecordsPerPage,
      this.isloggedInUserAdmin, orderBy, orderType).subscribe(
        result => {
          this.engagementCardList = result;
          this.initTooltip();
          console.log("engagementCardList ==>", this.engagementCardList);
          this.stopLoading();
          this.cardCount = this.engagementCardList.length;
          if (this.cardCount === 0) {
            this.DataMessage = ' No Data Available';
          } else if (this.cardCount === null) {
            this.DataMessage = 'Loading...';
          } else { this.DataMessage = ''; }

          this.applyFilterOnceAfterDataLoad = true;
        },
        err => console.log('Error in loading the client list information.'));
  }

  getMyEngagementListView(pageNumber: number,
    listViewnoOfrecordsPerPage, orderBy, orderType) {
    this.startLoading();
    this.engService.getMyEngagementListView(this.engagementListViewFilterModel, pageNumber,
      listViewnoOfrecordsPerPage, this.isloggedInUserAdmin, orderBy, orderType)
      .subscribe(
        result => {
          this.engagementList = result;
          console.log("engagementList ==>", this.engagementList);
          this.stopLoading();
          this.listCount = this.engagementList.length;
          if (this.listCount === 0) {
            this.listDataMessage = ' No Data Available';
          } else if (this.listCount === null) {
            this.DataMessage = 'Loading...';
          } else { this.listDataMessage = ''; }

          this.applyFilterOnceAfterDataLoad = true;
          this.setInitialsForListView();
        },
        err => console.log('Error in loading the client list information.'));
  }


  navigateEngagement(engagementId: number) {

    this.engService.GetEditEngagementDetailsById(engagementId).subscribe(
      result => {
        this.selectedEngagement = result;
        console.log('status ', this.selectedEngagement, this.selectedEngagement.status);
        switch (this.selectedEngagement.status) {
          case 'Not started':
            //EditEnagement\ID
            this.route.navigate(['EditEngagement/' + this.selectedEngagement.engagementId]);
            break;
          case 'Draft':
            //Interviews
            this.route.navigate(['Interviews/' + this.selectedEngagement.workspaceId]);
            break;
          case 'InReview':
          case 'Declined':
          case 'Abandoned':
            //Review\WorkSpaceId        
            this.route.navigate(['Review/' + this.selectedEngagement.workspaceId]);
            break;
          case 'Pending CMS codes':
          case 'CMS code error':
          case 'Active':
          case 'Closed':
          case EngagementStatus.EngActivePendingSignature:
          case EngagementStatus.EngVoided:
            this.route.navigate(['EngagementDetail/' + this.selectedEngagement.engagementId]);
          //EnagementDetails\ID 
          default:
            //Default;
            break;
        }
      },
      err => {
        console.log('Error in getting workspace status.', err);
      }
    );
  }

  navigateEngagement1(engagementId: number, SelectedView: string) {

    var selectedEngagementModel;

    if (SelectedView == 'Card') {
      selectedEngagementModel = this.engagementCardList.find(e => e.engagementId === engagementId);
    }
    else if (SelectedView == 'List') {
      selectedEngagementModel = this.engagementList.find(e => e.engagementId === engagementId);
    }
    console.log('status ', selectedEngagementModel, selectedEngagementModel.status);

    switch (selectedEngagementModel.status) {
      case 'Not started':
        //EditEnagement\ID
        this.route.navigate(['EditEngagement/' + selectedEngagementModel.engagementId]);
        break;
      case 'Draft':
        //Interviews
        this.route.navigate(['Interviews/' + selectedEngagementModel.workspaceId]);
        break;
      case 'InReview':
      case 'Declined':
      case 'Abandoned':
        //Review\WorkSpaceId        
        this.route.navigate(['Review/' + selectedEngagementModel.workspaceId]);
        break;
      case 'Pending CMS codes':
      case 'CMS code error':
      case 'Active':
      case 'Closed':
      case EngagementStatus.EngActivePendingSignature:
      case EngagementStatus.EngVoided:
        this.route.navigate(['EngagementDetail/' + selectedEngagementModel.engagementId]);
      //EnagementDetails\ID 
      default:
        //Default;
        break;
    }
  }

  getEngagementListByClient(clientId: number) {
    this.engService.getEngagementListViewByClient(clientId).subscribe(
      result => {
        this.engagementList = result;
        //console.log(this.englistViewList);
        this.applyFilterOnceAfterDataLoad = true;
      },
      err => console.log('Error in loading the engagement list information by client.', err));
  }

  InsertUpdateUserPreferenceData() {
    //alert(this.dashBoardViewtypeName);
    var userPrefData: UserPreferenceData;
    var cardViewFilterList: any;
    var cardViewSortList: any;
    var listViewFilterList: any;
    var listViewSortList: any;
    var datatoinsert = new UserPreferenceData();
    if (this.userPreferenceData.length > 0 && this.engagementUserPreference != null && this.passedClientId <= 0) {
      this.engagementUserPreference.userEmail = this.userObject.loggedInUserEmail;
      this.engagementUserPreference.dashBoardName = 'MyEngagements';
      this.engagementUserPreference.dashboardViewType = this.dashBoardViewtypeName;
      cardViewFilterList = this.engagementCardViewFilterModel;
      cardViewSortList = this.engagementCardViewFilterModel;
      listViewFilterList = this.engagementListViewFilterModel;
      listViewSortList = this.engagementListViewFilterModel;
      cardViewSortList.orderByType = $('#ddListOrderByType').val();

      listViewSortList.orderByColumn = this.orderByColumn;
      listViewSortList.orderByType = this.orderByType;
      this.engagementUserPreference.cardViewFilterList = JSON.stringify(cardViewFilterList);
      this.engagementUserPreference.cardViewSortingList = JSON.stringify(cardViewSortList);
      this.engagementUserPreference.cardViewPageNumber = this.cardViewnoOfrecordsPerPage;
      this.engagementUserPreference.listViewFilterList = JSON.stringify(listViewFilterList);
      this.engagementUserPreference.listViewSortingList = JSON.stringify(listViewSortList);
      this.engagementUserPreference.listViewPageNumber = this.listViewnoOfrecordsPerPage;
      userPrefData = this.engagementUserPreference;
      let index = this.userPreferenceData.findIndex(obj => obj.dashBoardName === "MyEngagements");
      this.userPreferenceData[index] = userPrefData;

      localStorage.setItem('userpreferencelist', JSON.stringify(this.userPreferenceData));


      this.engService.InsertUpdateUserPreferenceData(userPrefData).subscribe(result => {
        console.log(result);
      });
    }
    if (this.userPreferenceData.length > 0 && this.clientdetailUserPreference != null && this.passedClientId > 0) {
      this.clientdetailUserPreference.userEmail = this.userObject.loggedInUserEmail;
      this.clientdetailUserPreference.dashBoardName = 'ClientDetails';
      this.clientdetailUserPreference.dashboardViewType = this.dashBoardViewtypeName;


      cardViewFilterList = this.engagementCardViewForClientFilterModel;
      cardViewSortList = this.engagementCardViewForClientFilterModel;
      listViewFilterList = this.engagementListViewForClientFilterModel;
      listViewSortList = this.engagementListViewForClientFilterModel;
      cardViewSortList.sortOrderByTypeForClient = $('#ddListOrderByTypeForClient').val();

      listViewSortList.orderByColumn = this.orderByColumn;
      listViewSortList.orderByType = this.orderByType;
      this.clientdetailUserPreference.cardViewFilterList = JSON.stringify(cardViewFilterList);
      this.clientdetailUserPreference.cardViewSortingList = JSON.stringify(cardViewSortList);
      this.clientdetailUserPreference.cardViewPageNumber = this.cardViewnoOfrecordsPerPage;
      this.clientdetailUserPreference.listViewFilterList = JSON.stringify(listViewFilterList);
      this.clientdetailUserPreference.listViewSortingList = JSON.stringify(listViewSortList);
      this.clientdetailUserPreference.listViewPageNumber = this.listViewnoOfrecordsPerPage;
      userPrefData = this.clientdetailUserPreference;
      let index = this.userPreferenceData.findIndex(obj => obj.dashBoardName === "ClientDetails");
      this.userPreferenceData[index] = userPrefData;
      localStorage.setItem('userpreferencelist', JSON.stringify(this.userPreferenceData));


      this.engService.InsertUpdateUserPreferenceData(userPrefData).subscribe(result => {
        console.log(result);
      });
    }
    if ((this.userPreferenceData.length == 0 || this.userPreferenceData.length > 0) && this.engagementUserPreference == null && this.passedClientId <= 0) {

      cardViewFilterList = this.engagementCardViewFilterModel;
      cardViewSortList = this.engagementCardViewFilterModel;
      listViewFilterList = this.engagementListViewFilterModel;
      listViewSortList = this.engagementListViewFilterModel;
      cardViewSortList.orderByType = $('#ddListOrderByType').val();

      listViewSortList.orderByColumn = this.orderByColumn;
      listViewSortList.orderByType = this.orderByType;
      datatoinsert.userEmail = this.userObject.loggedInUserEmail;
      datatoinsert.dashBoardName = 'MyEngagements';
      datatoinsert.dashboardViewType = this.dashBoardViewtypeName;
      datatoinsert.cardViewPageNumber = this.cardViewnoOfrecordsPerPage;
      datatoinsert.listViewPageNumber = this.listViewnoOfrecordsPerPage;
      datatoinsert.cardViewFilterList = JSON.stringify(cardViewFilterList);
      datatoinsert.cardViewSortingList = JSON.stringify(cardViewSortList);
      datatoinsert.listViewFilterList = JSON.stringify(listViewFilterList);
      datatoinsert.listViewSortingList = JSON.stringify(listViewSortList);
      this.userPreferenceData.push(datatoinsert);
      localStorage.setItem('userpreferencelist', JSON.stringify(this.userPreferenceData));


      this.engService.InsertUpdateUserPreferenceData(datatoinsert).subscribe(result => {
        console.log(result);
      });
    }
    if ((this.userPreferenceData.length == 0 || this.userPreferenceData.length > 0) && this.clientdetailUserPreference == null && this.passedClientId > 0) {
      cardViewFilterList = this.engagementCardViewForClientFilterModel;
      cardViewSortList = this.engagementCardViewForClientFilterModel;
      listViewFilterList = this.engagementListViewForClientFilterModel;
      listViewSortList = this.engagementListViewForClientFilterModel;
      cardViewSortList.sortOrderByTypeForClient = $('#ddListOrderByTypeForClient').val();

      listViewSortList.orderByColumn = this.orderByColumn;
      listViewSortList.orderByType = this.orderByType;
      datatoinsert.userEmail = this.userObject.loggedInUserEmail;
      datatoinsert.dashBoardName = 'ClientDetails';
      datatoinsert.dashboardViewType = this.dashBoardViewtypeName;
      datatoinsert.cardViewPageNumber = this.cardViewnoOfrecordsPerPage;
      datatoinsert.listViewPageNumber = this.listViewnoOfrecordsPerPage;
      datatoinsert.cardViewFilterList = JSON.stringify(cardViewFilterList);
      datatoinsert.cardViewSortingList = JSON.stringify(cardViewSortList);
      datatoinsert.listViewFilterList = JSON.stringify(listViewFilterList);
      datatoinsert.listViewSortingList = JSON.stringify(listViewSortList);
      this.userPreferenceData.push(datatoinsert);
      localStorage.setItem('userpreferencelist', JSON.stringify(this.userPreferenceData));


      this.engService.InsertUpdateUserPreferenceData(datatoinsert).subscribe(result => {
        console.log(result);
      });
    }
  }

  ToggleListAndCardView(SelectedView: string,) {
    $("#showAllEngagementCardView").removeClass("active");
    $("#showAllEngagementListView").removeClass("active");
    if (this.isKPISelected)
      this.resetKPISelection(this.selectedKPI.kpiId);
    this.isKpiClickedMap = {};
    switch (SelectedView) {
      case 'Card':
        $('.Eng-ListView-Div').hide();
        $('.Eng-CardView-Div').show();
        if (this.passedClientId > 0) {
          $('#listViewFilterSectionForClient').hide();
          this.dashBoardViewtypeName = "Card";
          if (!this.isClientListViewApplyResetButtonClicked) {
            $("#filterEngagementListView").removeClass("partialActive");
            $("#filterEngagementListView").removeClass("active");
            this.engagementListViewForClientFilterModel = JSON.parse(this.clientdetailUserPreference.listViewFilterList);

          }

          this.InsertUpdateUserPreferenceData();
          this.getMyEngagementCountByClientId('Togggle', this.passedClientId);
          //this.cardViewSetPageByClientId(this.cardViewCurrentPageNumber, this.cardViewnoOfrecordsPerPage, this.passedClientId);
          if (this.engagementCardViewForClientFilterModel.solutionCodeId.length > 0 || this.engagementCardViewForClientFilterModel.industryTypeId.length > 0 ||
            this.engagementCardViewForClientFilterModel.engagementStatusId.length > 0 || this.engagementCardViewForClientFilterModel.eppmdEmail.length > 0) {
            $("#filterEngagementCardView").addClass("partialActive");
          }
          if (this.engagementCardViewForClientFilterModel.sortSolutionCodeId || this.engagementCardViewForClientFilterModel.sortIndustryTypeId ||
            this.engagementCardViewForClientFilterModel.sortEngagementStatusId || this.engagementCardViewForClientFilterModel.sortEppmdEmailId || this.engagementCardViewForClientFilterModel.sortLastActivityDate) {
            $("#sortEngagementCardView").addClass("partialActive");
          }
        }
        else {
          $('#listViewFilterSection').hide();
          this.dashBoardViewtypeName = "Card";
          if (!this.isListViewApplyResetButtonClicked) {
            $("#filterEngagementListView").removeClass("partialActive");
            $("#filterEngagementListView").removeClass("active");
            this.engagementListViewFilterModel = JSON.parse(this.engagementUserPreference.listViewFilterList);

          }

          this.InsertUpdateUserPreferenceData();
          this.getMyEngagementByUserCount('Toggle');
          $("#filterEngagementCardView").removeClass("active");
          if (this.engagementCardViewFilterModel.clientId.length > 0 || this.engagementCardViewFilterModel.solutionCodeId.length > 0 || this.engagementCardViewFilterModel.industryTypeId.length > 0 ||
            this.engagementCardViewFilterModel.engagementStatusId.length > 0 || this.engagementCardViewFilterModel.eppmdEmail.length > 0) {
            $("#filterEngagementCardView").addClass("partialActive");
          }
          if (this.engagementCardViewFilterModel.sortClientId || this.engagementCardViewFilterModel.sortSolutionCodeId || this.engagementCardViewFilterModel.sortIndustryTypeId ||
            this.engagementCardViewFilterModel.sortEngagementStatusId || this.engagementCardViewFilterModel.sortEppmdEmailId || this.engagementCardViewFilterModel.sortLastActivityDate) {
            $("#sortEngagementCardView").addClass("partialActive");
          }
        }
        this.SetDefaultCardView();
        break;
      case 'List':
        $('.Eng-ListView-Div').show();
        $('.Eng-CardView-Div').hide();
        if (this.passedClientId > 0) {
          $('#cardViewFilterSectionForMyClient').hide();
          $('#cardViewSortSectionForClient').hide();
          this.dashBoardViewtypeName = "List";
          if (!this.isClientCardViewApplyResetButtonClicked) {
            $("#filterEngagementCardView").removeClass("partialActive");
            $("#filterEngagementCardView").removeClass("active");

            this.engagementCardViewForClientFilterModel = JSON.parse(this.clientdetailUserPreference.cardViewFilterList);
          }
          if (!this.isClientCardViewSortApplyResetButtonClicked) {
            $("#sortEngagementCardView").removeClass("active");
            this.engagementCardViewForClientFilterModel = JSON.parse(this.clientdetailUserPreference.cardViewFilterList);
            this.sortOrderByTypeForClient = JSON.parse(this.clientdetailUserPreference.cardViewSortingList).sortOrderByTypeForClient;
            if (this.sortOrderByTypeForClient == undefined || this.sortOrderByTypeForClient == null) {
              this.sortOrderByTypeForClient = 'DESC';
            }
          }
          this.InsertUpdateUserPreferenceData();
          //this.listViewSetPage(this.listViewCurrentPageNumber, this.listViewnoOfrecordsPerPage);
          this.getMyEngagementListCountByClientId('Toggle', this.passedClientId);
          if (this.engagementListViewForClientFilterModel.solutionCodeId.length > 0 || this.engagementListViewForClientFilterModel.industryTypeId.length > 0 ||
            this.engagementListViewForClientFilterModel.engagementStatusId.length > 0 || this.engagementListViewForClientFilterModel.eppmdEmail.length > 0) {
            $("#filterEngagementListView").addClass("partialActive");
          }

        } else {
          this.dashBoardViewtypeName = "List";
          if (!this.isCardViewApplyResetButtonClicked) {
            $("#filterEngagementCardView").removeClass("partialActive");
            $("#filterEngagementCardView").removeClass("active");
            this.engagementCardViewFilterModel = JSON.parse(this.engagementUserPreference.cardViewFilterList);
          }
          if (!this.isCardViewSortApplyResetButtonClicked) {
            $("#sortEngagementCardView").removeClass("active");
            this.engagementCardViewFilterModel = JSON.parse(this.engagementUserPreference.cardViewFilterList);
            this.sortOrderByType = JSON.parse(this.engagementUserPreference.cardViewSortingList).orderByType;
            if (this.sortOrderByType == undefined || this.sortOrderByType == null) {
              this.sortOrderByType = 'DESC';
            }
          }
          this.InsertUpdateUserPreferenceData();
          this.listViewSetPage(this.listViewCurrentPageNumber, this.listViewnoOfrecordsPerPage);

          $("#filterEngagementListView").removeClass("active");
          if (this.engagementListViewFilterModel.clientId.length > 0 || this.engagementListViewFilterModel.solutionCodeId.length > 0 || this.engagementListViewFilterModel.industryTypeId.length > 0 ||
            this.engagementListViewFilterModel.engagementStatusId.length > 0 || this.engagementListViewFilterModel.eppmdEmail.length > 0) {
            $("#filterEngagementListView").addClass("partialActive");
          }

          $('#cardViewFilterSection').hide();
          $('#cardViewSortSection').hide();

        }



        break;
      default:
        this.SetDefaultCardView();
        break;
    }
    this.assignCheckBoxExistingFilterValue(this.userPreferenceData);
  }

  SetDefaultCardView() {
    $('.cardViewContainer').show();
    $('.Eng-ListView-Div').hide();
    $('.Eng-CardView-Div').show();
  }

  setKRPClientId(clientId: number) {
    this.selectedKRPClientId = clientId;
  }

  setEngagementId(engagementId: number) {
    // console.log('setEngagementId ', engagementId);
    this.selectedEngagementId = engagementId;
  }

  SetContactPopup(emailid: string) {
    this.selectContactEmailId = emailid;
  }

  createContactPopupDiv(controlIdText: string, id: number) {
    // console.log('engagementId ==>', id);
    $('#' + controlIdText + id).popover({
      container: 'body',
      html: true,
      placement: 'top',
      trigger: 'manual',
      boundary: 'viewport',
      content: function () {
        console.log('createContactPopupDiv func called ', $('#contact-popup').html());
        return '<div class=\"mx-auto\" style=\"width: 200px;\">Loading ...</div> ';
      }
    });
  }

  BindContactPopup() {
    this.engagementList.forEach(element => {
      this.createContactPopupDiv('ePPMDcontactPopup_', element.engagementId);
    });
    this.engagementCardList.forEach(element => {
      this.createContactPopupDiv('cardViewEPPMDcontactPopup_', element.engagementId);
    });
  }

  DisplayContactPopup(engagementid: number, emailid: string) {
    this.selectContactEmailId = emailid;
    $('#listViewtxtengId').val(engagementid);
    // Close the pop up if any pop up onen eariler
    this.hideAllPopUp();
    this.checkForContactContent('contact-popup');
    $('#ePPMDcontactPopup_' + engagementid).popover('show');
  }

  DisplayCardViewContactPopup(engagementid: number, emailid: string) {
    this.selectContactEmailId = emailid;
    $('#cardViewtxtengId').val(engagementid);
    // Close the pop up if any pop up onen eariler
    this.hideAllPopUp();
    this.checkForContactContent('contact-popup');
    $('#cardViewEPPMDcontactPopup_' + engagementid).popover('show');
  }

  hideAllPopUp() {
    if (this.engagementList !== null && this.engagementList !== undefined) {
      this.engagementList.forEach(element => {
        $('#ePPMDcontactPopup_' + element.engagementId).popover('hide');
      });
    }
    if (this.engagementCardList !== null && this.engagementCardList !== undefined) {
      this.engagementCardList.forEach(element => {
        $('#cardViewEPPMDcontactPopup_' + element.engagementId).popover('hide');
      });
    }
  }

  ngOnDestroy() {
    this.hideAllPopUp();
  }

  checkForContactContent(contact) {
    var timer = setTimeout(() => {
      const contactHtml = $('#' + contact).html();
      console.log('after 5 second', contact, contactHtml);
      if (contactHtml) {
        $('.popover-body').html(contactHtml);
        clearTimeout(timer);

      } else {
        this.checkForContactContent(contact);
      }
    }, 2000);
  }

  startLoading() {
    console.log('start loading ', this.isMyEngagementLevel);
    if (this.isMyEngagementLevel) {
      this.passLoading.emit('true');
    } else {
      this.loadingService.startLoading();
    }
  }

  stopLoading() {
    console.log('stop loading ', this.isMyEngagementLevel);
    if (this.isMyEngagementLevel) {
      this.passLoading.emit('false');
    } else {
      this.loadingService.stopLoading();
    }
  }

  getChangeOrderyByEngagmentId(engagementId: any) {

    this.changeOrderService.getChangeOrderHistory(engagementId).subscribe({
      next: result => {
        this.changeOrderHistoryList = result;
        $('#modal-Change-Order').modal('show');
      }, error: err => {
        $('#modal-Change-Order').modal('hide');
        console.error("failed to load change order history", err);
      }
    })
  }

  onSelect() {
    this.changeOrderHistoryList = [];
    $('#modal-Change-Order').modal('hide');
  }

  redirectChangeOrder(workspaceId: any, status: string) {
    var url;
    if (status != null) {
      switch (status) {
        case 'Draft':
          url = this.router.createUrlTree(['Interviews/' + workspaceId]);
          window.open(url, '_blank');
          break;
        default:
          url = this.router.createUrlTree(['Review/' + workspaceId]);
          window.open(url, '_blank');
          break;
      }
    } else {
      console.log('No status.');
    }
  }


  onItemValueChange(item: any) {

    if (item != null && item != undefined) {
      if (item.source == "engagementClient" && item.value != null) {
        this.clientIds = item.value;
      }
      if (item.source == "engagementIndustry") {
        this.industryIds = item.value;
      }
      if (item.source == "engagementStatus") {
        this.engagementStatusIds = item.value;
      }
      if (item.source == "engagementSolutionCode") {
        this.solutionCodeIds = item.value;
      }
      if (item.source == "engagementEPPMD") {
        this.eppmdIds = item.value;
      }
      if (item.source == "clientDetailsengagementIndustry") {
        this.clientDetailsIndustryIds = item.value;
      }
      if (item.source == "clientDetailsengagementStatus") {
        this.clientDetailsEngagementStatusIds = item.value;
      }

      if (item.source == "clientDetailsSolutionCode") {
        this.clientDetailsSolutionCodeIds = item.value;
      }
      if (item.source == "clientDetailsengagementEPPMD") {
        this.clientDetailsEPPMDSIds = item.value;
      }
    }
  }

  private assignFilterValuestoModal() {
    this.sharedService.subject.next('assign');
    this.resetFilterValuestoModal();
    this.assignFilterValuestoDataModal();
  }

  removeExtraValue(item: any) {
    if (item != null && item.length > 0) {
      if (item[0] == '-1') {
        item.shift();
      }
    }
    return item;
  }

  addExtaValueAll(source: string, item: any) {
    if (item != null && item.length > 0) {
      if (item[0] != '-1') {
        var keyValueList = new KeyValue();
        if (source == "engagementIndustry") {
          var itemValue = {
            "industryTypeId": -1,
            "industryTypeName": 'All'
          }
          item.unshift(itemValue);

        }

        if (source == "engagementClient") {
          var itemStructValue = {
            "clientId": -1,
            "clientName": 'All'
          }
          item.unshift(itemStructValue);
        }

        if (source == "engagementEPPMD") {
          var itemProgramValue = {
            "eppmdEmail": -1,
            "eppmdName": 'All'
          }
          item.unshift(itemProgramValue);
        }

        if (source == "engagementSolutionCode") {
          var itemStatusValue = {
            "solutionCodeId": -1,
            "solutionCodeName": 'All'
          }
          item.unshift(itemStatusValue);
        }

        if (source == "engagementStatus") {
          var itemEngagementStatusValue = {
            "engagementStatusId": -1,
            "engagementStatusName": 'All'
          }
          item.unshift(itemEngagementStatusValue);
        }



        if (source == "clientDetailsIndustry") {
          var itemValue = {
            "industryTypeId": -1,
            "industryTypeName": 'All'
          }
          item.unshift(itemValue);

        }

        if (source == "clientDetailsEPPMD") {
          var itemProgramValue = {
            "eppmdEmail": -1,
            "eppmdName": 'All'
          }
          item.unshift(itemProgramValue);
        }

        if (source == "clientDetailsSolutionCode") {
          var itemStatusValue = {
            "solutionCodeId": -1,
            "solutionCodeName": 'All'
          }
          item.unshift(itemStatusValue);
        }

        if (source == "clientDetailsEngagementStatus") {
          var itemEngagementStatusValue = {
            "engagementStatusId": -1,
            "engagementStatusName": 'All'
          }
          item.unshift(itemEngagementStatusValue);
        }

      }

    }
    return item;
  }

  private resetFilterValuesCheckBox() {
    this.clientIds = [];
    this.industryIds = [];
    this.solutionCodeIds = [];
    this.engagementStatusIds = [];
    this.eppmdIds = [];
    this.clientDetailsSolutionCodeIds = [];
    this.clientDetailsEPPMDSIds = [];
    this.clientDetailsEngagementStatusIds = [];
    this.clientDetailsIndustryIds = [];
  }

  resetFilterValuestoModal() {
    if (this.dashBoardViewtypeName?.toLocaleLowerCase() == "card") {
      this.engagementCardViewFilterModel.clientId = [];
      this.engagementCardViewFilterModel.solutionCodeId = [];
      this.engagementCardViewFilterModel.eppmdEmail = [];
      this.engagementCardViewFilterModel.industryTypeId = [];
      this.engagementCardViewFilterModel.engagementStatusId = [];
      this.engagementCardViewFilterModel.kpiId = 0;
    } else {
      this.engagementListViewFilterModel.clientId = [];
      this.engagementListViewFilterModel.solutionCodeId = [];
      this.engagementListViewFilterModel.eppmdEmail = [];
      this.engagementListViewFilterModel.industryTypeId = [];
      this.engagementListViewFilterModel.engagementStatusId = [];
      this.engagementListViewFilterModel.kpiId = 0;
    }
  }

  resetFilterValuestoClientDetailsModal() {
    if (this.dashBoardViewtypeName?.toLocaleLowerCase() == "card") {
      this.engagementCardViewForClientFilterModel.solutionCodeId = [];
      this.engagementCardViewForClientFilterModel.eppmdEmail = [];
      this.engagementCardViewForClientFilterModel.industryTypeId = [];
      this.engagementCardViewForClientFilterModel.engagementStatusId = [];
    } else {
      this.engagementListViewForClientFilterModel.solutionCodeId = [];
      this.engagementListViewForClientFilterModel.eppmdEmail = [];
      this.engagementListViewForClientFilterModel.industryTypeId = [];
      this.engagementListViewForClientFilterModel.engagementStatusId = [];
    }
  }
  private assignFilterValuestoDataModal() {
    if (this.dashBoardViewtypeName?.toLocaleLowerCase() == "card") {
      this.engagementCardViewFilterModel.clientId = this.clientIds;
      this.engagementCardViewFilterModel.solutionCodeId = this.solutionCodeIds;
      this.engagementCardViewFilterModel.eppmdEmail = this.eppmdIds;
      this.engagementCardViewFilterModel.engagementStatusId = this.engagementStatusIds;
      this.engagementCardViewFilterModel.industryTypeId = this.industryIds;
    } else {
      this.engagementListViewFilterModel.clientId = this.clientIds;
      this.engagementListViewFilterModel.solutionCodeId = this.solutionCodeIds;
      this.engagementListViewFilterModel.eppmdEmail = this.eppmdIds;
      this.engagementListViewFilterModel.engagementStatusId = this.engagementStatusIds;
      this.engagementListViewFilterModel.industryTypeId = this.industryIds;
    }
  }
  assignFilterValuestoClientDetailsModal() {
    this.sharedService.subject.next('assign');
    this.resetFilterValuestoClientDetailsModal();
    this.assignFilterValuestoClientDetailsDataModal();
  }

  private assignFilterValuestoClientDetailsDataModal() {
    if (this.dashBoardViewtypeName?.toLocaleLowerCase() == "card") {
      this.engagementCardViewForClientFilterModel.solutionCodeId = this.clientDetailsSolutionCodeIds;
      this.engagementCardViewForClientFilterModel.eppmdEmail = this.clientDetailsEPPMDSIds;
      this.engagementCardViewForClientFilterModel.engagementStatusId = this.clientDetailsEngagementStatusIds;
      this.engagementCardViewForClientFilterModel.industryTypeId = this.clientDetailsIndustryIds;
    } else {
      this.engagementListViewForClientFilterModel.solutionCodeId = this.clientDetailsSolutionCodeIds;
      this.engagementListViewForClientFilterModel.eppmdEmail = this.clientDetailsEPPMDSIds;
      this.engagementListViewForClientFilterModel.engagementStatusId = this.clientDetailsEngagementStatusIds;
      this.engagementListViewForClientFilterModel.industryTypeId = this.clientDetailsIndustryIds;
    }
  }
  private assignCheckBoxExistingFilterValue(userPreferenceData: UserPreferenceData[]) {  // preselect data from dropdown 
    if (userPreferenceData != null && this.dashBoardViewtypeName?.toLocaleLowerCase() == "card") {
      if (this.engagementUserPreference != null && this.engagementUserPreference != undefined
        && this.engagementUserPreference?.cardViewFilterList != null &&
        this.engagementUserPreference?.cardViewFilterList != undefined
      ) {
        this.engagementCardViewFilterModel = JSON.parse(this.engagementUserPreference?.cardViewFilterList);
        this.clientIds = this.engagementCardViewFilterModel.clientId;
        this.solutionCodeIds = this.engagementCardViewFilterModel.solutionCodeId;
        this.eppmdIds = this.engagementCardViewFilterModel.eppmdEmail;
        this.engagementStatusIds = this.engagementCardViewFilterModel.engagementStatusId;
        this.industryIds = this.engagementCardViewFilterModel.industryTypeId;
      }
      if (this.clientdetailUserPreference != null && this.clientdetailUserPreference != undefined
        && this.engagementUserPreference?.cardViewFilterList != null &&
        this.engagementUserPreference?.cardViewFilterList != undefined
      ) {
        this.engagementCardViewForClientFilterModel = JSON.parse(this.clientdetailUserPreference?.cardViewFilterList);
        this.clientDetailsSolutionCodeIds = this.engagementCardViewForClientFilterModel.solutionCodeId;
        this.clientDetailsEPPMDSIds = this.engagementCardViewForClientFilterModel.eppmdEmail;
        this.clientDetailsEngagementStatusIds = this.engagementCardViewForClientFilterModel.engagementStatusId;
        this.clientDetailsIndustryIds = this.engagementCardViewForClientFilterModel.industryTypeId;
      }

    } else if (userPreferenceData != null && this.dashBoardViewtypeName?.toLocaleLowerCase() == "list") {
      if (this.engagementUserPreference != null && this.engagementUserPreference != undefined) {
        this.engagementListViewFilterModel = JSON.parse(this.engagementUserPreference.listViewFilterList);
        this.clientIds = this.engagementListViewFilterModel.clientId;
        this.solutionCodeIds = this.engagementListViewFilterModel.solutionCodeId;
        this.eppmdIds = this.engagementListViewFilterModel.eppmdEmail;
        this.engagementStatusIds = this.engagementListViewFilterModel.engagementStatusId;
        this.industryIds = this.engagementListViewFilterModel.industryTypeId;
      }
      if (this.clientdetailUserPreference != null && this.clientdetailUserPreference != undefined) {
        this.engagementListViewForClientFilterModel = JSON.parse(this.clientdetailUserPreference?.listViewFilterList);
        this.clientDetailsSolutionCodeIds = this.engagementListViewForClientFilterModel.solutionCodeId;
        this.clientDetailsEPPMDSIds = this.engagementListViewForClientFilterModel.eppmdEmail;
        this.clientDetailsEngagementStatusIds = this.engagementListViewForClientFilterModel.engagementStatusId;
        this.clientDetailsIndustryIds = this.engagementListViewForClientFilterModel.industryTypeId;
      }
    }
  }
  getEngagementKpiDashboardDataByUser() {
    this.userDetails.loggedInUserEmail = this.userObject.loggedInUserEmail;
    this.kpiService.getEngagementKpiDashboardDataByUser(this.userDetails).subscribe({
      next: result => {
        this.engagementKpiDashboardDataModel = result;
      }, error: err => {
        console.error("failed to load Engagement Kpi Dashboard", err);
      }
    })
  }
  openKPIConfigPopup() {
    $('#modal-kpiConfig').modal({ backdrop: 'static', keyboard: false });
    $("#modal-kpiConfig").modal('show');
  }
  kpiPopupOkClicked(object: any) {
    if (object == "Success") {
      this.getEngagementKpiDashboardDataByUser();
      $("#modal-kpiConfig").modal('hide');
      if (this.selectedKPI != undefined) {
        this.resetKPISelection(this.selectedKPI.kpiId);
      }
      this.isKpiClickedMap = {};
      if (this.dashBoardViewtypeName === 'Card') {
        this.engagementCardViewFilterModel.kpiId = 0;
        this.getMyEngagementByUserCount('ShowAll');
      } else if (this.dashBoardViewtypeName === 'List') {
        this.engagementListViewFilterModel.kpiId = 0;
        this.getMyEngagementListByUserCount();
      }
    }
  }
  kpiPopupcloseClicked(object: any) {

  }

  showKpi(event: any, engkpiDashboard: KpiMaster) {
    const kpiId = engkpiDashboard.kpiId;
    const count = engkpiDashboard.kpiCount;

    if (event.type === "mouseover" && count !== "" && count !== "0") {
      if (!this.isKpiClickedMap[kpiId]) {
        $("#kpi_" + kpiId).addClass('kpi-active');
      }
    }
  }

  hideKpi(event: any, engkpiDashboard: KpiMaster) {
    const kpiId = engkpiDashboard.kpiId;
    const count = engkpiDashboard.kpiCount;

    if (event.type === "mouseleave" && !this.isKpiClickedMap[kpiId] && count !== "" && count !== "0") {
      $("#kpi_" + kpiId).removeClass('kpi-active');
    }
  }

  kpiclick(engkpiDashboard: KpiMaster) {
    this.cardViewCurrentPageNumber = 1;
    this.listViewCurrentPageNumber = 1;
    const kpiId = engkpiDashboard.kpiId;
    const count = engkpiDashboard.kpiCount;
    if (count !== "" && count !== "0") {
      if (this.selectedKPI?.kpiId != kpiId) {
        this.isKPISelected = true;
        this.selectedKPI = engkpiDashboard;
        // Toggle the clicked state
        this.isKpiClickedMap[kpiId] = !this.isKpiClickedMap[kpiId];

        for (const key in this.isKpiClickedMap) {
          if (this.isKpiClickedMap[key]) {
            this.isKpiClickedMap[key] = false;
            $("#kpi_" + key).removeClass('kpi-active');
          }
        }

        // Set the clicked KPI as active
        this.isKpiClickedMap[kpiId] = true;
        $("#kpi_" + kpiId).addClass('kpi-active');

        if (this.isKpiClickedMap[kpiId]) {
          $("#kpi_" + kpiId).addClass('kpi-active');
          if (this.dashBoardViewtypeName === 'Card') {
            this.loadingService.startLoading();
            $('#cardViewFilterSection').hide();
            $('#cardViewSortSection').hide();
            this.engagementCardViewFilterModel.kpiId = kpiId;
            this.engService.getMyEngagementCardViewByUserCount(this.isloggedInUserAdmin, this.engagementCardViewFilterModel).subscribe(
              result => {
                this.engagementCount = result;
                this.stopLoading();

                if (this.engagementCount > 0) {
                  $("#filterEngagementCardView").removeClass("active");
                  $("#sortEngagementCardView").removeClass("active");
                  $("#showAllEngagementCardView").removeClass("active");
                  this.cardViewSetPageWhenKpiSelected(this.cardViewCurrentPageNumber, this.cardViewnoOfrecordsPerPage);
                }
              });
          } else if (this.dashBoardViewtypeName === 'List') {
            this.loadingService.startLoading();
            $('#listViewFilterSection').hide();
            this.engagementListViewFilterModel.kpiId = kpiId;
            this.engService.getMyEngagementListViewByUserCount(this.isloggedInUserAdmin, this.engagementListViewFilterModel).subscribe(
              result => {
                this.engagementListCount = result;
                this.stopLoading();
                if (this.engagementListCount > 0) {
                  $("#filterEngagementListView").removeClass("active");
                  $("#showAllEngagementListView").removeClass("active");
                  this.listViewSetPageWhenKpiSelected(this.listViewCurrentPageNumber, this.listViewnoOfrecordsPerPage);
                }
              });
          }
        } else {
          $("#kpi_" + kpiId).removeClass('kpi-active');
          if (this.dashBoardViewtypeName === 'Card') {
            this.engagementCardViewFilterModel.kpiId = 0;
            this.getMyEngagementByUserCount('ShowAll');
          } else if (this.dashBoardViewtypeName === 'List') {
            this.engagementListViewFilterModel.kpiId = 0;
            this.getMyEngagementListByUserCount();
          }
        }
      }
      else {
        if (this.selectedKPI != undefined) {
          this.resetKPISelection(this.selectedKPI.kpiId);
        }
        this.isKpiClickedMap = {};
        if (this.dashBoardViewtypeName === 'Card') {
          this.engagementCardViewFilterModel.kpiId = 0;
          this.getMyEngagementByUserCount('ShowAll');
        } else if (this.dashBoardViewtypeName === 'List') {
          this.engagementListViewFilterModel.kpiId = 0;
          this.getMyEngagementListByUserCount();
        }
      }
    }
  }

  cardViewSetPageWhenKpiSelected(pageNumber: number, recordsPerPage: number) {
    // get CardViewpager object from service
    this.cardViewCurrentPageNumber = pageNumber;
    const inputDrpValue = $('#cardViewdrprecordsPerPage option:selected').text();
    if (inputDrpValue === '') {
      this.cardViewnoOfrecordsPerPage = recordsPerPage;
    } else {
      this.cardViewnoOfrecordsPerPage = Number(inputDrpValue);
    }
    if (this.cardViewCurrentPageNumber != 0) {

      if (this.sortOrderByType != null && this.sortOrderByType != "") {
        this.cardVieworderByType = this.sortOrderByType;
        //this.resetCardViewSortCheckBox();
      }
      this.getMyEngagementCardView(this.cardViewCurrentPageNumber,
        this.cardViewnoOfrecordsPerPage,
        this.cardVieworderByColumn, this.cardVieworderByType);
      this.cardViewPager = this.pagerService.getPager(this.engagementCount, this.cardViewCurrentPageNumber, this.cardViewnoOfrecordsPerPage);
    } else {
      $('#cardViewPrevious').off('click');
      $('#cardViewFirst').off('click');
    }
    console.log('cardViewPager ==>', this.cardViewPager);
  }

  listViewSetPageWhenKpiSelected(pageNumber: number, recordsPerPage: number) {
    // get pager object from service this.passedClientId
    this.listViewCurrentPageNumber = pageNumber;
    const inputDrpValue = $('#drprecordsPerPage option:selected').text();
    if (inputDrpValue === '') {
      this.listViewnoOfrecordsPerPage = recordsPerPage;
    } else {
      this.listViewnoOfrecordsPerPage = Number(inputDrpValue);
    }
    if (this.listViewCurrentPageNumber != 0) {
      this.getMyEngagementListView(this.listViewCurrentPageNumber,
        this.listViewnoOfrecordsPerPage,
        this.orderByColumn, this.orderByType);
      this.pager = this.pagerService.getPager(this.engagementListCount, this.listViewCurrentPageNumber, this.listViewnoOfrecordsPerPage);
      console.log('pager ==>', this.pager);
    } else {
      $('#previous').off('click');
      $('#first').off('click');
    }
  }

  resetKPISelection(kpiId: number) {
    this.isKPISelected = false;
    this.selectedKPI = undefined;
    $("#kpi_" + kpiId).removeClass('kpi-active');
  }

  resetCardViewSortCheckBox() {
    $('#chkClientName').prop('checked', false);
    $('#chkSolutionCode').prop('checked', false);
    $('#chkEppmd').prop('checked', false);
    $('#chkIndustryType').prop('checked', false);
    $('#chkEngagementStatus').prop('checked', false);
    $('#chkLastActivityDate').prop('checked', true);
    $('#ddListOrderByType').val('DESC');
  }
}